// src/enums/index.ts
var OrderStatus = {
  PENDING: "PENDING",
  CONFIRMED: "CONFIRMED",
  PACKED: "PACKED",
  SHIPPED: "SHIPPED",
  OUT_FOR_DELIVERY: "OUT_FOR_DELIVERY",
  DELIVERED: "DELIVERED",
  FAILED: "FAILED",
  RETURN_REQUESTED: "RETURN_REQUESTED",
  RETURNED: "RETURNED",
  CANCELLED: "CANCELLED",
  REFUNDED: "REFUNDED"
};
var EDITABLE_ORDER_STATUSES = [
  OrderStatus.PENDING,
  OrderStatus.CONFIRMED,
  OrderStatus.PACKED
];
var REVENUE_ORDER_STATUSES = [OrderStatus.DELIVERED];
var PaymentStatus = {
  UNPAID: "UNPAID",
  AUTHORIZED: "AUTHORIZED",
  PAID: "PAID",
  PARTIALLY_REFUNDED: "PARTIALLY_REFUNDED",
  REFUNDED: "REFUNDED"
};
var PaymentMethod = {
  COD: "COD",
  CARD: "CARD",
  BANK_TRANSFER: "BANK_TRANSFER",
  LOYALTY: "LOYALTY"
};
var DeliveryType = {
  HOME: "HOME",
  STOP_DESK: "STOP_DESK"
};
var ShipmentStatus = {
  CREATED: "CREATED",
  PICKED_UP: "PICKED_UP",
  IN_TRANSIT: "IN_TRANSIT",
  OUT_FOR_DELIVERY: "OUT_FOR_DELIVERY",
  DELIVERED: "DELIVERED",
  FAILED: "FAILED",
  RETURNED: "RETURNED",
  CANCELLED: "CANCELLED"
};
var DeliveryFailureReason = {
  NO_ANSWER: "NO_ANSWER",
  REFUSED: "REFUSED",
  WRONG_ADDRESS: "WRONG_ADDRESS",
  CUSTOMER_ABSENT: "CUSTOMER_ABSENT",
  RESCHEDULED: "RESCHEDULED",
  DAMAGED: "DAMAGED",
  OTHER: "OTHER"
};
var DeliveryRunStatus = {
  PLANNED: "PLANNED",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED"
};
var SettlementStatus = {
  OPEN: "OPEN",
  SENT: "SENT",
  PAID: "PAID",
  DISPUTED: "DISPUTED"
};
var CallOutcome = {
  CONFIRMED: "CONFIRMED",
  NO_ANSWER: "NO_ANSWER",
  CANCELLED: "CANCELLED",
  CALL_BACK: "CALL_BACK",
  WRONG_NUMBER: "WRONG_NUMBER"
};
var ProductStatus = {
  DRAFT: "DRAFT",
  ACTIVE: "ACTIVE",
  ARCHIVED: "ARCHIVED"
};
var StockMovementReason = {
  PURCHASE: "PURCHASE",
  SALE: "SALE",
  RETURN: "RETURN",
  ADJUSTMENT: "ADJUSTMENT",
  TRANSFER: "TRANSFER",
  DAMAGED: "DAMAGED",
  STOCK_COUNT: "STOCK_COUNT",
  RESERVATION: "RESERVATION",
  RELEASE: "RELEASE"
};
var PromotionType = {
  PERCENTAGE: "PERCENTAGE",
  FIXED_AMOUNT: "FIXED_AMOUNT",
  FREE_SHIPPING: "FREE_SHIPPING",
  BUY_X_GET_Y: "BUY_X_GET_Y",
  BUNDLE_PRICE: "BUNDLE_PRICE",
  TIERED: "TIERED"
};
var PromotionScope = {
  ORDER: "ORDER",
  PRODUCT: "PRODUCT",
  VARIANT: "VARIANT",
  COLLECTION: "COLLECTION",
  CATEGORY: "CATEGORY",
  SHIPPING: "SHIPPING"
};
var MediaKind = {
  IMAGE: "IMAGE",
  VIDEO: "VIDEO",
  MODEL_3D: "MODEL_3D",
  DOCUMENT: "DOCUMENT"
};
var UserType = {
  STAFF: "STAFF",
  CUSTOMER: "CUSTOMER"
};
var RoleSlug = {
  OWNER: "owner",
  MANAGER: "manager",
  ORDER_AGENT: "order_agent",
  WAREHOUSE: "warehouse",
  DRIVER: "driver",
  MARKETING: "marketing",
  ACCOUNTANT: "accountant"
};
var Locale = {
  FR: "fr",
  AR: "ar",
  EN: "en"
};
var LOCALES = [Locale.FR, Locale.AR, Locale.EN];
var DEFAULT_LOCALE = Locale.FR;
var RTL_LOCALES = [Locale.AR];
var OrderSource = {
  WEB: "WEB",
  PHONE: "PHONE",
  INSTAGRAM: "INSTAGRAM",
  FACEBOOK: "FACEBOOK",
  TIKTOK: "TIKTOK",
  WHATSAPP: "WHATSAPP",
  ADMIN: "ADMIN"
};
var ReturnCondition = {
  RESELLABLE: "RESELLABLE",
  DAMAGED: "DAMAGED",
  MISSING_PARTS: "MISSING_PARTS"
};
var PurchaseOrderStatus = {
  DRAFT: "DRAFT",
  ORDERED: "ORDERED",
  PARTIALLY_RECEIVED: "PARTIALLY_RECEIVED",
  RECEIVED: "RECEIVED",
  CANCELLED: "CANCELLED"
};
var CustomerSegment = {
  NEW: "NEW",
  RETURNING: "RETURNING",
  VIP: "VIP",
  AT_RISK: "AT_RISK",
  BLACKLISTED: "BLACKLISTED"
};
var NotificationChannel = {
  SMS: "SMS",
  EMAIL: "EMAIL",
  WHATSAPP: "WHATSAPP",
  TELEGRAM: "TELEGRAM",
  IN_APP: "IN_APP"
};
var CollectionRuleField = {
  TAG: "TAG",
  CATEGORY: "CATEGORY",
  BRAND: "BRAND",
  PRICE: "PRICE",
  DISCOUNT: "DISCOUNT",
  STOCK: "STOCK",
  CREATED_AT: "CREATED_AT",
  TITLE: "TITLE"
};
var RuleOperator = {
  EQUALS: "EQUALS",
  NOT_EQUALS: "NOT_EQUALS",
  CONTAINS: "CONTAINS",
  GREATER_THAN: "GREATER_THAN",
  LESS_THAN: "LESS_THAN",
  IN: "IN"
};
var ReviewStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED"
};
var RULE_OPERATORS_BY_FIELD = {
  TAG: ["EQUALS", "NOT_EQUALS", "IN"],
  CATEGORY: ["EQUALS", "NOT_EQUALS"],
  BRAND: ["EQUALS", "NOT_EQUALS"],
  PRICE: ["GREATER_THAN", "LESS_THAN"],
  DISCOUNT: ["GREATER_THAN"],
  STOCK: ["GREATER_THAN", "LESS_THAN"],
  CREATED_AT: ["GREATER_THAN"],
  TITLE: ["CONTAINS", "EQUALS", "NOT_EQUALS"]
};

// src/enums/permissions.ts
var PERMISSIONS = [
  // Catalog
  "catalog.read",
  "catalog.write",
  "catalog.delete",
  "reviews.moderate",
  // Inventory
  "inventory.read",
  "inventory.write",
  "purchasing.read",
  "purchasing.write",
  // Orders
  "orders.read",
  "orders.write",
  "orders.transition",
  "orders.cancel",
  "orders.refund",
  "orders.documents",
  // Customers
  "customers.read",
  "customers.write",
  "customers.blacklist",
  // Promotions & marketing
  "promotions.read",
  "promotions.write",
  "content.read",
  "content.write",
  "marketing.read",
  "marketing.write",
  // Delivery
  "delivery.read",
  "delivery.write",
  "delivery.dispatch",
  "delivery.own_runs",
  // a driver sees only their own run — PRD acceptance criterion 6
  "delivery.settle",
  // Finance
  "finance.read",
  "finance.write",
  "reports.read",
  "reports.export",
  // System
  "settings.read",
  "settings.write",
  "users.read",
  "users.write",
  "audit.read"
];
var ALL = [...PERMISSIONS];
var MANAGER = ALL.filter(
  (p) => !p.startsWith("finance.") && !p.startsWith("settings.") && !p.startsWith("users.") && p !== "audit.read"
);
var ROLE_PERMISSIONS = {
  [RoleSlug.OWNER]: ALL,
  [RoleSlug.MANAGER]: MANAGER,
  [RoleSlug.ORDER_AGENT]: [
    "orders.read",
    "orders.write",
    "orders.transition",
    "orders.cancel",
    "customers.read",
    "customers.write",
    "catalog.read",
    "inventory.read",
    "promotions.read",
    "delivery.read"
  ],
  [RoleSlug.WAREHOUSE]: [
    "orders.read",
    "orders.transition",
    "orders.documents",
    "inventory.read",
    "inventory.write",
    "purchasing.read",
    "catalog.read",
    "delivery.read"
  ],
  [RoleSlug.DRIVER]: ["delivery.own_runs", "orders.read"],
  [RoleSlug.MARKETING]: [
    "catalog.read",
    "catalog.write",
    "promotions.read",
    "promotions.write",
    "content.read",
    "content.write",
    "marketing.read",
    "marketing.write",
    "reports.read",
    "customers.read",
    "reviews.moderate"
  ],
  [RoleSlug.ACCOUNTANT]: [
    "finance.read",
    "finance.write",
    "reports.read",
    "reports.export",
    "orders.read",
    "delivery.read",
    "delivery.settle",
    "inventory.read",
    "purchasing.read"
  ]
};
var PERMISSION_GROUPS = {
  Catalog: ["catalog.read", "catalog.write", "catalog.delete", "reviews.moderate"],
  Inventory: ["inventory.read", "inventory.write", "purchasing.read", "purchasing.write"],
  Orders: [
    "orders.read",
    "orders.write",
    "orders.transition",
    "orders.cancel",
    "orders.refund",
    "orders.documents"
  ],
  Customers: ["customers.read", "customers.write", "customers.blacklist"],
  Marketing: [
    "promotions.read",
    "promotions.write",
    "content.read",
    "content.write",
    "marketing.read",
    "marketing.write"
  ],
  Delivery: [
    "delivery.read",
    "delivery.write",
    "delivery.dispatch",
    "delivery.own_runs",
    "delivery.settle"
  ],
  Finance: ["finance.read", "finance.write", "reports.read", "reports.export"],
  System: ["settings.read", "settings.write", "users.read", "users.write", "audit.read"]
};

// src/finance/pnl.ts
function computePnl(input) {
  const grossProfitMinor = input.revenueMinor - input.cogsMinor;
  const shippingMarginMinor = input.shippingRevenueMinor - input.shippingCostMinor;
  const contributionMinor = grossProfitMinor + shippingMarginMinor;
  const netProfitMinor = contributionMinor - input.paymentFeesMinor - input.refundsMinor - input.expensesMinor - input.adSpendMinor;
  return {
    ...input,
    grossProfitMinor,
    shippingMarginMinor,
    contributionMinor,
    netProfitMinor,
    grossMarginPercent: shareOf(grossProfitMinor, input.revenueMinor),
    netMarginPercent: shareOf(netProfitMinor, input.revenueMinor)
  };
}
function shareOf(part, base) {
  if (base === 0n) return 0;
  const scaled = part * 1000n / base;
  return Number(scaled) / 10;
}
function emptyPnl() {
  return {
    revenueMinor: 0n,
    cogsMinor: 0n,
    shippingRevenueMinor: 0n,
    shippingCostMinor: 0n,
    discountsMinor: 0n,
    paymentFeesMinor: 0n,
    refundsMinor: 0n,
    expensesMinor: 0n,
    adSpendMinor: 0n
  };
}
function addPnl(a, b) {
  return {
    revenueMinor: a.revenueMinor + b.revenueMinor,
    cogsMinor: a.cogsMinor + b.cogsMinor,
    shippingRevenueMinor: a.shippingRevenueMinor + b.shippingRevenueMinor,
    shippingCostMinor: a.shippingCostMinor + b.shippingCostMinor,
    discountsMinor: a.discountsMinor + b.discountsMinor,
    paymentFeesMinor: a.paymentFeesMinor + b.paymentFeesMinor,
    refundsMinor: a.refundsMinor + b.refundsMinor,
    expensesMinor: a.expensesMinor + b.expensesMinor,
    adSpendMinor: a.adSpendMinor + b.adSpendMinor
  };
}
function allocateByRevenue(totalMinor, groups) {
  const allocation = /* @__PURE__ */ new Map();
  if (groups.length === 0) return allocation;
  const totalRevenue = groups.reduce((sum2, group) => sum2 + group.revenueMinor, 0n);
  if (totalRevenue <= 0n) {
    const each = totalMinor / BigInt(groups.length);
    let remainder2 = totalMinor - each * BigInt(groups.length);
    for (const group of groups) {
      const extra = remainder2 > 0n ? 1n : 0n;
      allocation.set(group.key, each + extra);
      remainder2 -= extra;
    }
    return allocation;
  }
  let assigned = 0n;
  for (const group of groups) {
    const share = totalMinor * group.revenueMinor / totalRevenue;
    allocation.set(group.key, share);
    assigned += share;
  }
  const remainder = totalMinor - assigned;
  if (remainder !== 0n) {
    const largest = [...groups].sort(
      (a, b) => a.revenueMinor === b.revenueMinor ? 0 : a.revenueMinor > b.revenueMinor ? -1 : 1
    )[0];
    allocation.set(largest.key, (allocation.get(largest.key) ?? 0n) + remainder);
  }
  return allocation;
}
function changePercent(current, previous) {
  if (previous === 0n) return null;
  const scaled = (current - previous) * 1000n / (previous < 0n ? -previous : previous);
  return Number(scaled) / 10;
}
function roas(revenueMinor, adSpendMinor) {
  if (adSpendMinor <= 0n) return null;
  return Number(revenueMinor * 100n / adSpendMinor) / 100;
}
function costPerOrder(adSpendMinor, orders) {
  if (orders <= 0 || adSpendMinor <= 0n) return null;
  return adSpendMinor / BigInt(orders);
}

// src/money/index.ts
var CURRENCIES = {
  DZD: { decimals: 2, symbol: "DA", symbolPosition: "after" },
  EUR: { decimals: 2, symbol: "\u20AC", symbolPosition: "before" },
  USD: { decimals: 2, symbol: "$", symbolPosition: "before" }
};
var DEFAULT_CURRENCY = "DZD";
var CurrencyMismatchError = class extends Error {
  constructor(a, b) {
    super(`Cannot combine ${a} with ${b}`);
    this.name = "CurrencyMismatchError";
  }
};
function money(amount, currency = DEFAULT_CURRENCY) {
  return { amount: toBigInt(amount), currency };
}
function zero(currency = DEFAULT_CURRENCY) {
  return { amount: 0n, currency };
}
function fromMajor(value, currency = DEFAULT_CURRENCY) {
  const meta = CURRENCIES[currency];
  const text = typeof value === "number" ? value.toFixed(meta.decimals) : value.trim();
  const negative = text.startsWith("-");
  const [whole = "0", frac = ""] = text.replace(/^[+-]/, "").split(".");
  const padded = (frac + "0".repeat(meta.decimals)).slice(0, meta.decimals);
  const carry = frac.length > meta.decimals && Number(frac[meta.decimals]) >= 5 ? 1n : 0n;
  const amount = BigInt(whole) * 10n ** BigInt(meta.decimals) + BigInt(padded || "0") + carry;
  return { amount: negative ? -amount : amount, currency };
}
function toMajorNumber(m) {
  return Number(m.amount) / 10 ** CURRENCIES[m.currency].decimals;
}
function add(a, b) {
  assertSame(a, b);
  return { amount: a.amount + b.amount, currency: a.currency };
}
function subtract(a, b) {
  assertSame(a, b);
  return { amount: a.amount - b.amount, currency: a.currency };
}
function sum(items, currency = DEFAULT_CURRENCY) {
  return items.reduce((acc, item) => add(acc, item), zero(currency));
}
function multiply(m, factor) {
  if (typeof factor === "bigint") return { amount: m.amount * factor, currency: m.currency };
  return { amount: scaleHalfUp(m.amount, factor), currency: m.currency };
}
function negate(m) {
  return { amount: -m.amount, currency: m.currency };
}
function isZero(m) {
  return m.amount === 0n;
}
function isNegative(m) {
  return m.amount < 0n;
}
function compare(a, b) {
  assertSame(a, b);
  if (a.amount < b.amount) return -1;
  if (a.amount > b.amount) return 1;
  return 0;
}
function max(a, b) {
  return compare(a, b) >= 0 ? a : b;
}
function min(a, b) {
  return compare(a, b) <= 0 ? a : b;
}
function clampToZero(m) {
  return m.amount < 0n ? zero(m.currency) : m;
}
function percentOf(m, percent) {
  return { amount: scaleHalfUp(m.amount, percent / 100), currency: m.currency };
}
function allocate(m, weights) {
  const total = weights.reduce((a, b) => a + b, 0);
  if (weights.length === 0 || total <= 0) {
    throw new Error("allocate() requires at least one positive weight");
  }
  const out = [];
  let assigned = 0n;
  for (const weight of weights) {
    const share = scaleHalfUp(m.amount, weight / total);
    out.push(share);
    assigned += share;
  }
  let remainder = m.amount - assigned;
  const step = remainder < 0n ? -1n : 1n;
  for (let i = 0; remainder !== 0n; i = (i + 1) % out.length) {
    out[i] = out[i] + step;
    remainder -= step;
  }
  return out.map((amount) => ({ amount, currency: m.currency }));
}
function marginPercent(price, cost) {
  assertSame(price, cost);
  if (price.amount === 0n) return null;
  const margin = Number(price.amount - cost.amount) / Number(price.amount);
  return Math.round(margin * 1e3) / 10;
}
function discountPercent(compareAt, price) {
  assertSame(compareAt, price);
  if (compareAt.amount <= price.amount || compareAt.amount === 0n) return 0;
  return Math.round(Number(compareAt.amount - price.amount) / Number(compareAt.amount) * 100);
}
function taxIncluded(gross, ratePercent) {
  const divisor = 1 + ratePercent / 100;
  const net = scaleHalfUp(gross.amount, 1 / divisor);
  return { amount: gross.amount - net, currency: gross.currency };
}
function format(m, opts = {}) {
  const { locale = "fr-DZ", withSymbol = true, compact = false } = opts;
  const meta = CURRENCIES[m.currency];
  const value = toMajorNumber(m);
  const body = new Intl.NumberFormat(locale, {
    minimumFractionDigits: compact ? 0 : meta.decimals,
    maximumFractionDigits: compact ? 0 : meta.decimals,
    notation: compact ? "compact" : "standard"
  }).format(value);
  if (!withSymbol) return body;
  return meta.symbolPosition === "after" ? `${body} ${meta.symbol}` : `${meta.symbol}${body}`;
}
function assertSame(a, b) {
  if (a.currency !== b.currency) throw new CurrencyMismatchError(a.currency, b.currency);
}
function toBigInt(value) {
  if (typeof value === "bigint") return value;
  if (typeof value === "string") return BigInt(value);
  if (!Number.isInteger(value)) {
    throw new TypeError(`money() needs an integer of minor units, received ${value}`);
  }
  return BigInt(value);
}
function scaleHalfUp(amount, factor) {
  const PRECISION = 1000000n;
  const scaled = BigInt(Math.round(factor * Number(PRECISION)));
  const product = amount * scaled;
  const negative = product < 0n;
  const abs = negative ? -product : product;
  const quotient = abs / PRECISION;
  const remainder = abs % PRECISION;
  const rounded = remainder * 2n >= PRECISION ? quotient + 1n : quotient;
  return negative ? -rounded : rounded;
}

// src/phone/index.ts
var MOBILE_LENGTH = 9;
var LANDLINE_LENGTH = 8;
var DZ_COUNTRY_CODE = "213";
var InvalidPhoneError = class extends Error {
  constructor(input, reason) {
    super(`Invalid phone number "${input}": ${reason}`);
    this.reason = reason;
    this.name = "InvalidPhoneError";
  }
  reason;
};
function clean(input) {
  const trimmed = input.trim().replace(/[\s.\-()/]/g, "");
  if (trimmed.startsWith("00")) return `+${trimmed.slice(2)}`;
  return trimmed;
}
function significantDigits(input) {
  const value = clean(input);
  if (!/^\+?\d+$/.test(value)) return null;
  const digits = value.replace(/^\+/, "");
  if (digits.startsWith(DZ_COUNTRY_CODE)) {
    const rest = digits.slice(DZ_COUNTRY_CODE.length).replace(/^0/, "");
    return rest;
  }
  if (digits.startsWith("0")) return digits.slice(1);
  if (digits.length === MOBILE_LENGTH && /^[5-7]/.test(digits)) return digits;
  if (digits.length === LANDLINE_LENGTH && /^[2-4]/.test(digits)) return digits;
  return null;
}
function isValidDzPhone(input) {
  return parseDzPhoneOrNull(input) !== null;
}
function parseDzPhoneOrNull(input) {
  try {
    return parseDzPhone(input);
  } catch {
    return null;
  }
}
function parseDzPhone(input) {
  if (!input) throw new InvalidPhoneError(input, "empty");
  const significant = significantDigits(input);
  if (significant === null) throw new InvalidPhoneError(input, "not an Algerian number");
  const lead = significant[0] ?? "";
  if (!/[2-7]/.test(lead)) {
    throw new InvalidPhoneError(input, `unknown prefix 0${lead}`);
  }
  const isMobile = /[5-7]/.test(lead);
  const expected = isMobile ? MOBILE_LENGTH : LANDLINE_LENGTH;
  if (significant.length !== expected) {
    throw new InvalidPhoneError(
      input,
      `expected ${expected} significant digits, got ${significant.length}`
    );
  }
  return {
    e164: `+${DZ_COUNTRY_CODE}${significant}`,
    national: formatNational(significant, isMobile),
    countryCode: DZ_COUNTRY_CODE,
    isMobile,
    carrier: carrierOf(lead, isMobile)
  };
}
function normalizeDzPhone(input) {
  return parseDzPhone(input).e164;
}
function carrierOf(lead, isMobile) {
  if (!isMobile) return "unknown";
  if (lead === "5") return "ooredoo";
  if (lead === "6") return "mobilis";
  if (lead === "7") return "djezzy";
  return "unknown";
}
function formatNational(significant, isMobile) {
  const national = `0${significant}`;
  return isMobile ? `${national.slice(0, 4)} ${national.slice(4, 6)} ${national.slice(6, 8)} ${national.slice(8)}` : `${national.slice(0, 3)} ${national.slice(3, 5)} ${national.slice(5, 7)} ${national.slice(7)}`;
}
function whatsappLink(input, message) {
  const digits = normalizeDzPhone(input).replace("+", "");
  const query = message ? `?text=${encodeURIComponent(message)}` : "";
  return `https://wa.me/${digits}${query}`;
}
function telLink(input) {
  return `tel:${normalizeDzPhone(input)}`;
}
function maskPhone(input) {
  const parsed = parseDzPhoneOrNull(input);
  if (!parsed) return "\u2022\u2022\u2022";
  const digits = parsed.e164.slice(1 + DZ_COUNTRY_CODE.length);
  const hidden = "\u2022".repeat(Math.max(digits.length - 4, 1));
  return `+${DZ_COUNTRY_CODE} ${digits.slice(0, 2)}${hidden}${digits.slice(-2)}`;
}

// src/i18n/index.ts
var FALLBACK_CHAIN = {
  fr: ["fr", "en", "ar"],
  en: ["en", "fr", "ar"],
  ar: ["ar", "fr", "en"]
};
function t(field, locale = DEFAULT_LOCALE) {
  if (!field) return "";
  for (const candidate of FALLBACK_CHAIN[locale] ?? FALLBACK_CHAIN[DEFAULT_LOCALE]) {
    const value = field[candidate];
    if (value != null && value.trim() !== "") return value;
  }
  return "";
}
function isFullyTranslated(field) {
  if (!field) return false;
  return LOCALES.every((locale) => (field[locale] ?? "").trim() !== "");
}
function missingLocales(field) {
  return LOCALES.filter((locale) => (field?.[locale] ?? "").trim() === "");
}
function translated(fr, ar, en) {
  const out = { fr };
  if (ar) out.ar = ar;
  if (en) out.en = en;
  return out;
}
function isRtl(locale) {
  return RTL_LOCALES.includes(locale);
}
function dir(locale) {
  return isRtl(locale) ? "rtl" : "ltr";
}
function isLocale(value) {
  return LOCALES.includes(value);
}
function negotiateLocale(header) {
  if (!header) return DEFAULT_LOCALE;
  const ranked = header.split(",").map((part) => {
    const [tag = "", q = "q=1"] = part.trim().split(";");
    return { tag: (tag.split("-")[0] ?? "").toLowerCase(), q: Number(q.replace("q=", "")) || 0 };
  }).sort((a, b) => b.q - a.q);
  for (const { tag } of ranked) {
    if (isLocale(tag)) return tag;
  }
  return DEFAULT_LOCALE;
}
function slugify(input) {
  return input.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 96);
}

// src/schemas/common.ts
import { z } from "zod";
var idSchema = z.string().uuid();
var localeSchema = z.enum(LOCALES);
var translatedSchema = z.object({
  fr: z.string().min(1, "French value is required"),
  ar: z.string().optional(),
  en: z.string().optional()
}).strict();
var translatedOptionalSchema = z.object({ fr: z.string().optional(), ar: z.string().optional(), en: z.string().optional() }).strict();
var slugSchema = z.string().min(1).max(96).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, "Slug must be lowercase words joined by hyphens");
var moneyAmountSchema = z.union([z.string().regex(/^-?\d+$/), z.number().int()]).transform((value) => BigInt(value));
var positiveMoneySchema = moneyAmountSchema.refine(
  (value) => value >= 0n,
  "Amount cannot be negative"
);
var dzPhoneSchema = z.string().min(9).max(20).refine(isValidDzPhone, "Enter a valid Algerian phone number (05, 06 or 07)").transform(normalizeDzPhone);
var emailSchema = z.string().email().max(255).toLowerCase();
var paginationSchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  perPage: z.coerce.number().int().min(1).max(200).default(24),
  cursor: z.string().optional()
});
var sortSchema = z.object({
  sortBy: z.string().max(64).optional(),
  sortDir: z.enum(["asc", "desc"]).default("desc")
});
var dateRangeSchema = z.object({
  from: z.coerce.date().optional(),
  to: z.coerce.date().optional()
}).refine((range) => !range.from || !range.to || range.from <= range.to, {
  message: "`from` must not be after `to`",
  path: ["from"]
});

// src/schemas/admin.ts
import { z as z2 } from "zod";
var SORT_DIRECTIONS = ["asc", "desc"];
var EXPORT_FORMATS = ["csv", "xlsx"];
var adminListQuerySchema = z2.object({
  page: z2.coerce.number().int().min(1).default(1),
  /** Capped so a careless client cannot ask for the whole table in one request. */
  pageSize: z2.coerce.number().int().min(1).max(100).default(50),
  sort: z2.string().max(64).optional(),
  order: z2.enum(SORT_DIRECTIONS).default("desc"),
  /** Free-text search; each module decides which columns it covers. */
  q: z2.string().trim().max(160).optional(),
  /** Streams a file instead of JSON. */
  format: z2.enum(EXPORT_FORMATS).optional()
});
var EXPORT_INLINE_LIMIT = 5e3;
var EXPORT_MAX_ROWS = 5e4;
var savedViewStateSchema = z2.object({
  filters: z2.record(z2.union([z2.string(), z2.array(z2.string())])).default({}),
  sort: z2.string().max(64).optional(),
  order: z2.enum(SORT_DIRECTIONS).optional(),
  pageSize: z2.coerce.number().int().min(1).max(100).optional(),
  q: z2.string().max(160).optional(),
  /** Column id to visibility; absent columns keep the module default. */
  columns: z2.record(z2.boolean()).optional(),
  density: z2.enum(["comfortable", "compact"]).optional()
});
var savedViewInputSchema = z2.object({
  module: z2.string().trim().min(2).max(48).regex(/^[a-z][a-z0-9-]*$/, "Module keys are lowercase words joined by hyphens"),
  name: z2.string().trim().min(1).max(120),
  state: savedViewStateSchema,
  isDefault: z2.boolean().default(false),
  isShared: z2.boolean().default(false)
});
var savedViewUpdateSchema = savedViewInputSchema.partial().omit({ module: true });
var bulkIdsSchema = z2.object({
  ids: z2.array(idSchema).min(1, "Select at least one row").max(500)
});
var ADMIN_EVENTS = [
  "connected",
  "ping",
  "order.created",
  "order.transitioned",
  "shipment.updated",
  "inventory.low",
  "notification"
];
var globalSearchQuerySchema = z2.object({
  q: z2.string().trim().min(1).max(120),
  limit: z2.coerce.number().int().min(1).max(20).default(5)
});
var STOREFRONT_CACHE_TAGS = [
  "products",
  "collections",
  "home",
  "bootstrap",
  "reviews",
  "sitemap",
  "pages"
];

// src/schemas/auth.ts
import { z as z3 } from "zod";
var staffLoginSchema = z3.object({
  email: emailSchema,
  password: z3.string().min(8).max(128),
  totp: z3.string().regex(/^\d{6}$/).optional()
});
var otpRequestSchema = z3.object({
  phone: dzPhoneSchema,
  purpose: z3.enum(["login", "checkout", "verify"]).default("login")
});
var otpVerifySchema = z3.object({
  phone: dzPhoneSchema,
  code: z3.string().regex(/^\d{6}$/, "The code is 6 digits")
});
var refreshSchema = z3.object({
  refreshToken: z3.string().min(16).optional()
});
var passwordSchema = z3.string().min(10, "Use at least 10 characters").max(128).refine((v) => /[a-z]/.test(v) && /[A-Z]/.test(v) && /\d/.test(v), {
  message: "Include an upper case letter, a lower case letter and a digit"
});
var changePasswordSchema = z3.object({
  currentPassword: z3.string().min(1),
  newPassword: passwordSchema,
  confirmPassword: z3.string()
}).refine((v) => v.newPassword === v.confirmPassword, {
  message: "The two passwords do not match",
  path: ["confirmPassword"]
});
var inviteStaffSchema = z3.object({
  email: emailSchema,
  name: z3.string().min(2).max(120),
  phone: dzPhoneSchema.optional(),
  roleSlugs: z3.array(z3.string().min(1)).min(1, "Pick at least one role")
});
var acceptInviteSchema = z3.object({
  token: z3.string().min(16),
  password: passwordSchema
});
var enable2faSchema = z3.object({
  secret: z3.string().min(16),
  code: z3.string().regex(/^\d{6}$/)
});

// src/schemas/cart.ts
import { z as z4 } from "zod";
var cartItemInputSchema = z4.object({
  variantId: idSchema,
  quantity: z4.coerce.number().int().min(1).max(99)
});
var cartItemPatchSchema = z4.object({
  /** Zero removes the line — one code path for "remove" and "set to zero". */
  quantity: z4.coerce.number().int().min(0).max(99)
});
var cartPromoSchema = z4.object({
  code: z4.string().trim().min(2).max(48).toUpperCase()
});
var cartDeliverySchema = z4.object({
  wilayaCode: z4.coerce.number().int().min(1).max(58).nullable().optional(),
  deliveryType: z4.nativeEnum(DeliveryType).nullable().optional()
});
var CART_ERRORS = {
  CART_NOT_FOUND: "CART_NOT_FOUND",
  VARIANT_UNAVAILABLE: "VARIANT_UNAVAILABLE",
  OUT_OF_STOCK: "OUT_OF_STOCK",
  CART_EMPTY: "CART_EMPTY",
  PROMO_REJECTED: "PROMO_REJECTED"
};
var CART_COOKIE = "jk_cart";
var CART_TTL_DAYS = 30;

// src/schemas/catalog.ts
import { z as z5 } from "zod";
var variantInputSchema = z5.object({
  id: idSchema.optional(),
  sku: z5.string().trim().min(2).max(64).regex(/^[A-Za-z0-9._-]+$/, "SKU may contain letters, digits, dot, dash and underscore"),
  barcode: z5.string().trim().max(64).optional(),
  price: positiveMoneySchema,
  compareAtPrice: positiveMoneySchema.optional(),
  costPrice: positiveMoneySchema.default(0),
  weightGrams: z5.coerce.number().int().min(0).max(5e4).default(0),
  optionValueIds: z5.array(idSchema).default([]),
  mediaIds: z5.array(idSchema).default([]),
  position: z5.coerce.number().int().min(0).default(0),
  active: z5.boolean().default(true)
});
var productAttributeSchema = z5.object({
  key: z5.string().trim().min(1).max(64),
  value: translatedSchema
});
var productInputBase = z5.object({
  name: translatedSchema,
  slug: slugSchema,
  description: translatedOptionalSchema.optional(),
  shortDescription: translatedOptionalSchema.optional(),
  status: z5.nativeEnum(ProductStatus).default(ProductStatus.DRAFT),
  brandId: idSchema.nullable().optional(),
  categoryId: idSchema.nullable().optional(),
  collectionIds: z5.array(idSchema).default([]),
  tagIds: z5.array(idSchema).default([]),
  styleLabel: z5.string().trim().max(64).optional(),
  sizeGuideId: idSchema.nullable().optional(),
  attributes: z5.array(productAttributeSchema).default([]),
  seoTitle: translatedOptionalSchema.optional(),
  seoDescription: translatedOptionalSchema.optional(),
  publishedAt: z5.coerce.date().nullable().optional(),
  lowStockThreshold: z5.coerce.number().int().min(0).default(5),
  allowBackorder: z5.boolean().default(false),
  trackInventory: z5.boolean().default(true),
  shippingClass: z5.string().trim().max(64).optional(),
  relatedProductIds: z5.array(idSchema).default([]),
  mediaIds: z5.array(idSchema).default([]),
  variants: z5.array(variantInputSchema).min(1, "A product needs at least one variant")
});
var productSuperRefine = (value, ctx) => {
  const skus = value.variants.map((v) => v.sku.toLowerCase());
  const duplicate = skus.find((sku, i) => skus.indexOf(sku) !== i);
  if (duplicate) {
    ctx.addIssue({
      code: z5.ZodIssueCode.custom,
      path: ["variants"],
      message: `Duplicate SKU "${duplicate}" within the product`
    });
  }
  value.variants.forEach((variant, index) => {
    if (variant.compareAtPrice != null && variant.compareAtPrice <= variant.price) {
      ctx.addIssue({
        code: z5.ZodIssueCode.custom,
        path: ["variants", index, "compareAtPrice"],
        message: "Compare-at price must be higher than the selling price"
      });
    }
  });
};
var productInputSchema = productInputBase.superRefine(productSuperRefine);
var optionSetSchema = z5.object({
  name: translatedSchema,
  position: z5.coerce.number().int().min(0).default(0),
  values: z5.array(
    z5.object({
      id: idSchema.optional(),
      name: translatedSchema,
      /** Hex swatch for colour options — drives the PDP colour chips (F-ST-31). */
      swatchHex: z5.string().regex(/^#[0-9a-fA-F]{6}$/).optional(),
      position: z5.coerce.number().int().min(0).default(0)
    })
  ).min(1)
});
var categoryInputSchema = z5.object({
  name: translatedSchema,
  slug: slugSchema,
  description: translatedOptionalSchema.optional(),
  parentId: idSchema.nullable().optional(),
  position: z5.coerce.number().int().min(0).default(0),
  mediaId: idSchema.nullable().optional(),
  seoTitle: translatedOptionalSchema.optional(),
  seoDescription: translatedOptionalSchema.optional()
});
var collectionRuleSchema = z5.object({
  field: z5.enum(["TAG", "CATEGORY", "BRAND", "PRICE", "DISCOUNT", "STOCK", "CREATED_AT", "TITLE"]),
  operator: z5.enum(["EQUALS", "NOT_EQUALS", "CONTAINS", "GREATER_THAN", "LESS_THAN", "IN"]),
  value: z5.string().min(1).max(240)
});
var collectionInputBase = z5.object({
  name: translatedSchema,
  slug: slugSchema,
  description: translatedOptionalSchema.optional(),
  isSmart: z5.boolean().default(false),
  matchAll: z5.boolean().default(true),
  rules: z5.array(collectionRuleSchema).default([]),
  productIds: z5.array(idSchema).default([]),
  mediaId: idSchema.nullable().optional(),
  position: z5.coerce.number().int().min(0).default(0),
  published: z5.boolean().default(true)
});
var collectionSuperRefine = (value, ctx) => {
  if (value.isSmart && value.rules.length === 0) {
    ctx.addIssue({
      code: z5.ZodIssueCode.custom,
      path: ["rules"],
      message: "A smart collection needs at least one rule"
    });
  }
};
var collectionInputSchema = collectionInputBase.superRefine(collectionSuperRefine);
var mediaUploadSchema = z5.object({
  kind: z5.nativeEnum(MediaKind).default(MediaKind.IMAGE),
  alt: translatedOptionalSchema.optional(),
  folderId: idSchema.nullable().optional()
});
var catalogQuerySchema = z5.object({
  q: z5.string().trim().max(120).optional(),
  collection: z5.string().max(96).optional(),
  category: z5.string().max(96).optional(),
  brand: z5.array(z5.string().max(96)).or(z5.string().max(96)).optional(),
  color: z5.array(z5.string().max(96)).or(z5.string().max(96)).optional(),
  size: z5.array(z5.string().max(96)).or(z5.string().max(96)).optional(),
  material: z5.array(z5.string().max(96)).or(z5.string().max(96)).optional(),
  tag: z5.array(z5.string().max(96)).or(z5.string().max(96)).optional(),
  minPrice: moneyAmountSchema.optional(),
  maxPrice: moneyAmountSchema.optional(),
  inStock: z5.coerce.boolean().optional(),
  onSale: z5.coerce.boolean().optional(),
  sort: z5.enum([
    "relevance",
    "best_selling",
    "newest",
    "price_asc",
    "price_desc",
    "name_asc",
    "name_desc",
    "discount"
  ]).default("relevance"),
  page: z5.coerce.number().int().min(1).default(1),
  perPage: z5.coerce.number().int().min(1).max(60).default(24)
});
var reviewInputSchema = z5.object({
  productId: idSchema,
  rating: z5.coerce.number().int().min(1).max(5),
  title: z5.string().trim().max(120).optional(),
  body: z5.string().trim().min(10, "Tell us a little more").max(2e3),
  authorName: z5.string().trim().min(2).max(80),
  mediaIds: z5.array(idSchema).max(5).default([])
});

// src/schemas/catalog-admin.ts
import { z as z6 } from "zod";
var productListQuerySchema = adminListQuerySchema;
var STOCK_STATES = ["in", "low", "out"];
var productPatchSchema = productInputBase.omit({ variants: true }).partial();
var productDuplicateSchema = z6.object({
  name: translatedSchema.optional(),
  slug: slugSchema.optional(),
  includeMedia: z6.boolean().default(true),
  includeVariants: z6.boolean().default(true)
});
var productBulkPriceSchema = z6.object({
  mode: z6.enum(["set", "increase", "decrease"]),
  /** Exactly one of the two: a flat amount in minor units, or a percentage. */
  amountMinor: positiveMoneySchema.optional(),
  percent: z6.coerce.number().min(0).max(500).optional(),
  target: z6.enum(["price", "compareAtPrice", "costPrice"]).default("price")
});
var productBulkUpdateSchema = z6.object({
  ids: z6.array(idSchema).min(1, "Select at least one product").max(500),
  status: z6.nativeEnum(ProductStatus).optional(),
  categoryId: idSchema.nullable().optional(),
  brandId: idSchema.nullable().optional(),
  addCollectionIds: z6.array(idSchema).default([]),
  removeCollectionIds: z6.array(idSchema).default([]),
  addTagIds: z6.array(idSchema).default([]),
  removeTagIds: z6.array(idSchema).default([]),
  price: productBulkPriceSchema.optional()
}).superRefine((value, ctx) => {
  if (value.price) {
    const hasAmount = value.price.amountMinor !== void 0;
    const hasPercent = value.price.percent !== void 0;
    if (hasAmount === hasPercent) {
      ctx.addIssue({
        code: z6.ZodIssueCode.custom,
        path: ["price"],
        message: "Give either an amount or a percentage, not both"
      });
    }
  }
  const touchesSomething = value.status !== void 0 || value.categoryId !== void 0 || value.brandId !== void 0 || value.addCollectionIds.length > 0 || value.removeCollectionIds.length > 0 || value.addTagIds.length > 0 || value.removeTagIds.length > 0 || value.price !== void 0;
  if (!touchesSomething) {
    ctx.addIssue({
      code: z6.ZodIssueCode.custom,
      path: ["ids"],
      message: "Choose at least one change to apply"
    });
  }
});
var productArchiveSchema = z6.object({
  ids: z6.array(idSchema).min(1).max(500),
  /** `false` restores an archived product to draft. */
  archived: z6.boolean().default(true)
});
var variantGenerateSchema = z6.object({
  options: z6.array(optionSetSchema).min(1).max(3),
  /** Seeds newly created combinations; existing ones keep what they had. */
  price: positiveMoneySchema,
  compareAtPrice: positiveMoneySchema.optional(),
  costPrice: positiveMoneySchema.default(0),
  weightGrams: z6.coerce.number().int().min(0).max(5e4).default(0),
  /** Prefix for generated SKUs; the option values are appended. */
  skuPrefix: z6.string().trim().min(1).max(24).regex(/^[A-Za-z0-9._-]+$/, "A SKU prefix takes letters, digits, dot, dash, underscore")
});
var variantsPatchSchema = z6.object({
  variants: z6.array(variantInputSchema).min(1).max(300)
});
var variantReorderSchema = z6.object({
  ids: z6.array(idSchema).min(1).max(300)
});
var priceScheduleInputSchema = z6.object({
  variantIds: z6.array(idSchema).min(1).max(300),
  price: positiveMoneySchema,
  compareAtPrice: positiveMoneySchema.nullable().optional(),
  startsAt: z6.coerce.date(),
  endsAt: z6.coerce.date().nullable().optional()
}).superRefine((value, ctx) => {
  if (value.endsAt && value.endsAt <= value.startsAt) {
    ctx.addIssue({
      code: z6.ZodIssueCode.custom,
      path: ["endsAt"],
      message: "The end must come after the start"
    });
  }
});
var categoryCreateSchema = categoryInputSchema.extend({
  published: z6.boolean().optional()
});
var categoryPatchSchema = categoryInputSchema.partial().extend({
  published: z6.boolean().optional()
});
var categoryMoveSchema = z6.object({
  parentId: idSchema.nullable(),
  position: z6.coerce.number().int().min(0)
});
var categoryReorderSchema = z6.object({
  items: z6.array(
    z6.object({
      id: idSchema,
      parentId: idSchema.nullable(),
      position: z6.coerce.number().int().min(0)
    })
  ).min(1).max(500)
});
var collectionPatchSchema = z6.object({
  name: translatedSchema.optional(),
  slug: slugSchema.optional(),
  description: translatedOptionalSchema.optional(),
  isSmart: z6.boolean().optional(),
  matchAll: z6.boolean().optional(),
  rules: z6.array(collectionRuleSchema).optional(),
  mediaId: idSchema.nullable().optional(),
  heroMediaId: idSchema.nullable().optional(),
  position: z6.coerce.number().int().min(0).optional(),
  published: z6.boolean().optional(),
  seoTitle: translatedOptionalSchema.optional(),
  seoDescription: translatedOptionalSchema.optional()
});
var collectionPreviewSchema = z6.object({
  rules: z6.array(collectionRuleSchema).min(1).max(20),
  matchAll: z6.boolean().default(true),
  limit: z6.coerce.number().int().min(1).max(50).default(12)
});
var collectionProductsSchema = z6.object({
  productIds: z6.array(idSchema).min(1).max(500)
});
var collectionReorderSchema = z6.object({
  productIds: z6.array(idSchema).min(1).max(500)
});
var merchandisingSchema = z6.object({
  items: z6.array(
    z6.object({
      productId: idSchema,
      pinned: z6.boolean().optional(),
      hidden: z6.boolean().optional(),
      boost: z6.coerce.number().int().min(-100).max(100).optional(),
      position: z6.coerce.number().int().min(0).optional()
    })
  ).min(1).max(500)
});
var synonymInputSchema = z6.object({
  term: z6.string().trim().min(2).max(80).toLowerCase(),
  synonyms: z6.array(z6.string().trim().min(2).max(80).toLowerCase()).min(1, "Add at least one synonym").max(20),
  twoWay: z6.boolean().default(true),
  active: z6.boolean().default(true)
});
var brandInputSchema = z6.object({
  name: z6.string().trim().min(1).max(120),
  slug: slugSchema,
  description: translatedOptionalSchema.optional(),
  logoMediaId: idSchema.nullable().optional()
});
var tagInputSchema = z6.object({
  name: translatedSchema,
  slug: slugSchema.max(64)
});
var attributeInputSchema = z6.object({
  key: z6.string().trim().min(1).max(64).regex(/^[a-z][a-z0-9_]*$/, "A key is lowercase letters, digits and underscores"),
  name: translatedSchema,
  kind: z6.enum(["text", "number", "select"]).default("text"),
  /** Allowed values when `kind` is `select`. */
  options: z6.array(translatedSchema).optional(),
  filterable: z6.boolean().default(true),
  position: z6.coerce.number().int().min(0).default(0)
}).superRefine((value, ctx) => {
  if (value.kind === "select" && (value.options ?? []).length === 0) {
    ctx.addIssue({
      code: z6.ZodIssueCode.custom,
      path: ["options"],
      message: "A select attribute needs its list of values"
    });
  }
});
var sizeGuideInputSchema = z6.object({
  name: translatedSchema,
  /** Rich HTML per locale, rendered on the product page. */
  body: translatedSchema,
  categoryId: idSchema.nullable().optional()
});
var reviewListQuerySchema = adminListQuerySchema;
var reviewModerationSchema = z6.object({
  ids: z6.array(idSchema).min(1, "Select at least one review").max(200),
  status: z6.enum([ReviewStatus.APPROVED, ReviewStatus.REJECTED, ReviewStatus.PENDING])
});
var reviewReplySchema = z6.object({
  /** An empty string clears an earlier reply. */
  reply: z6.string().trim().max(2e3)
});
var IMPORT_COLUMNS = [
  "sku",
  "name_fr",
  "name_ar",
  "name_en",
  "slug",
  "status",
  "brand",
  "category",
  "tags",
  "price",
  "compare_at_price",
  "cost_price",
  "weight_grams",
  "barcode",
  "short_description_fr",
  "description_fr"
];
var REQUIRED_IMPORT_COLUMNS = ["sku", "name_fr", "price"];
var productImportOptionsSchema = z6.object({
  /** Validates and reports without writing anything. */
  dryRun: z6.coerce.boolean().default(true),
  /** A row whose SKU already exists updates that variant instead of being skipped. */
  updateExisting: z6.coerce.boolean().default(true)
});
var IMPORT_MAX_ROWS = 5e3;
var CATALOG_ERRORS = {
  SLUG_TAKEN: "That slug is already used by another entry",
  SKU_TAKEN: "That SKU is already used",
  CATEGORY_CYCLE: "A category cannot be moved inside its own subtree",
  CATEGORY_HAS_CHILDREN: "Move or delete the sub-categories first",
  IN_USE: "Something still points at this entry",
  SMART_COLLECTION_MANUAL: "A smart collection is filled by its rules, not by hand",
  LAST_VARIANT: "A product needs at least one variant"
};

// src/schemas/checkout.ts
import { z as z7 } from "zod";
var checkoutBase = z7.object({
  cartToken: z7.string().min(8).max(128),
  customer: z7.object({
    fullName: z7.string().trim().min(3, "Enter your full name").max(120),
    phone: dzPhoneSchema,
    altPhone: dzPhoneSchema.optional(),
    email: emailSchema.optional()
  }),
  shipping: z7.object({
    wilayaCode: z7.coerce.number().int().min(1).max(58),
    communeId: idSchema,
    deliveryType: z7.nativeEnum(DeliveryType),
    /** Required for HOME delivery, ignored for STOP_DESK. */
    address: z7.string().trim().max(400).optional(),
    /** Required for STOP_DESK, ignored for HOME. */
    pickupPointId: idSchema.optional(),
    note: z7.string().trim().max(500).optional()
  }),
  payment: z7.object({
    method: z7.nativeEnum(PaymentMethod).default(PaymentMethod.COD)
  }),
  promoCode: z7.string().trim().min(2).max(48).optional(),
  loyaltyPointsToRedeem: z7.coerce.number().int().min(0).default(0),
  source: z7.nativeEnum(OrderSource).default(OrderSource.WEB),
  utm: z7.object({
    source: z7.string().max(120).optional(),
    medium: z7.string().max(120).optional(),
    campaign: z7.string().max(120).optional(),
    content: z7.string().max(120).optional(),
    term: z7.string().max(120).optional()
  }).optional(),
  /** Turnstile / hCaptcha token, demanded only after N attempts (F-ST-44). */
  captchaToken: z7.string().max(4096).optional(),
  acceptsMarketing: z7.boolean().default(false)
});
function requireDeliveryTarget(value, ctx) {
  if (value.shipping.deliveryType === DeliveryType.HOME) {
    if (!value.shipping.address || value.shipping.address.length < 8) {
      ctx.addIssue({
        code: z7.ZodIssueCode.custom,
        path: ["shipping", "address"],
        message: "Home delivery needs a street address"
      });
    }
  } else if (!value.shipping.pickupPointId) {
    ctx.addIssue({
      code: z7.ZodIssueCode.custom,
      path: ["shipping", "pickupPointId"],
      message: "Choose a pickup point"
    });
  }
}
var checkoutSchema = checkoutBase.superRefine(requireDeliveryTarget);
var quickOrderSchema = checkoutBase.omit({ cartToken: true, loyaltyPointsToRedeem: true }).extend({
  variantId: idSchema,
  quantity: z7.coerce.number().int().min(1).max(10).default(1)
}).superRefine(requireDeliveryTarget);
var quickPromoSchema = z7.object({
  variantId: idSchema,
  quantity: z7.coerce.number().int().min(1).max(10).default(1),
  code: z7.string().trim().min(2).max(48),
  wilayaCode: z7.coerce.number().int().min(1).max(58).optional(),
  deliveryType: z7.nativeEnum(DeliveryType).optional()
});
var shippingQuoteSchema = z7.object({
  wilayaCode: z7.coerce.number().int().min(1).max(58),
  deliveryType: z7.nativeEnum(DeliveryType).default(DeliveryType.HOME),
  weightGrams: z7.coerce.number().int().min(0).default(0),
  subtotal: z7.coerce.number().int().min(0).optional()
});
var abandonedCartPingSchema = z7.object({
  cartToken: z7.string().min(8).max(128),
  phone: dzPhoneSchema.optional(),
  fullName: z7.string().trim().max(120).optional(),
  wilayaCode: z7.coerce.number().int().min(1).max(58).optional()
});

// src/schemas/content.ts
import { z as z8 } from "zod";
var HOME_SECTION_KINDS = [
  "hero_3d",
  "featured_collections",
  "new_arrivals",
  "best_sellers",
  "promo_countdown",
  "promo_banner",
  "lookbook",
  "brand_story",
  "testimonials",
  "newsletter"
];
var homeSectionInputSchema = z8.object({
  kind: z8.enum(HOME_SECTION_KINDS),
  title: translatedOptionalSchema.nullable().optional(),
  subtitle: translatedOptionalSchema.nullable().optional(),
  ctaLabel: translatedOptionalSchema.nullable().optional(),
  ctaUrl: z8.string().trim().max(400).nullable().optional(),
  mediaId: idSchema.nullable().optional(),
  collectionId: idSchema.nullable().optional(),
  productId: idSchema.nullable().optional(),
  /** Section-specific knobs: item counts, a model URL, a countdown target. */
  config: z8.record(z8.unknown()).nullable().optional(),
  position: z8.coerce.number().int().min(0).max(999).default(0),
  active: z8.boolean().default(true),
  startsAt: z8.coerce.date().nullable().optional(),
  endsAt: z8.coerce.date().nullable().optional()
});
var reorderSchema = z8.object({
  ids: z8.array(idSchema).min(1).max(200)
});
var BANNER_PLACEMENTS = [
  "home_hero",
  "home_mid",
  "collection_top",
  "product_side",
  "cart_upsell"
];
var bannerInputSchema = z8.object({
  name: z8.string().trim().min(1).max(120),
  placement: z8.enum(BANNER_PLACEMENTS),
  title: translatedOptionalSchema.nullable().optional(),
  subtitle: translatedOptionalSchema.nullable().optional(),
  ctaLabel: translatedOptionalSchema.nullable().optional(),
  ctaUrl: z8.string().trim().max(400).nullable().optional(),
  mediaId: idSchema.nullable().optional(),
  position: z8.coerce.number().int().min(0).max(999).default(0),
  active: z8.boolean().default(true),
  startsAt: z8.coerce.date().nullable().optional(),
  endsAt: z8.coerce.date().nullable().optional()
});
var announcementInputSchema = z8.object({
  message: translatedSchema,
  linkUrl: z8.string().trim().max(400).nullable().optional(),
  bgColor: z8.string().regex(/^#[0-9a-fA-F]{6}$/, "Use a hex colour like #1B2A45").nullable().optional(),
  textColor: z8.string().regex(/^#[0-9a-fA-F]{6}$/, "Use a hex colour like #FFFFFF").nullable().optional(),
  position: z8.coerce.number().int().min(0).max(999).default(0),
  active: z8.boolean().default(true),
  startsAt: z8.coerce.date().nullable().optional(),
  endsAt: z8.coerce.date().nullable().optional()
});
var PAGE_KINDS = ["page", "post", "legal"];
var pageInputSchema = z8.object({
  slug: slugSchema,
  title: translatedSchema,
  /** Rich text, stored as a translated document the storefront renders. */
  body: translatedSchema,
  excerpt: translatedOptionalSchema.nullable().optional(),
  heroMediaId: idSchema.nullable().optional(),
  seoTitle: translatedOptionalSchema.nullable().optional(),
  seoDescription: translatedOptionalSchema.nullable().optional(),
  kind: z8.enum(PAGE_KINDS).default("page"),
  published: z8.boolean().default(false)
});
var menuInputSchema = z8.object({
  slug: slugSchema,
  name: translatedSchema
});
var menuItemInputSchema = z8.object({
  parentId: idSchema.nullable().optional(),
  label: translatedSchema,
  url: z8.string().trim().min(1).max(400),
  imageKey: z8.string().trim().max(400).nullable().optional(),
  position: z8.coerce.number().int().min(0).max(999).default(0),
  openInNewTab: z8.boolean().default(false)
});
var redirectInputSchema = z8.object({
  fromPath: z8.string().trim().min(1).max(400).startsWith("/", "A path starts with /"),
  toPath: z8.string().trim().min(1).max(400),
  statusCode: z8.union([z8.literal(301), z8.literal(302)]).default(301)
}).refine((input) => input.fromPath !== input.toPath, {
  message: "A redirect to itself is a loop",
  path: ["toPath"]
});
var NEWSLETTER_PROVIDERS = ["log", "brevo"];
var newsletterSyncSchema = z8.object({
  /** Only subscribers added since this date; omit for everyone. */
  since: z8.coerce.date().optional()
});
var contactCartSchema = z8.object({
  cartIds: z8.array(idSchema).min(1).max(100)
});
var affiliateInputSchema = z8.object({
  name: z8.string().trim().min(1).max(160),
  handle: z8.string().trim().min(2).max(64).regex(/^[a-z0-9][a-z0-9._-]*$/, "Lowercase letters, digits, dots, dashes"),
  phone: z8.string().trim().max(20).nullable().optional(),
  email: z8.string().trim().email().max(255).nullable().optional(),
  promotionId: idSchema.nullable().optional(),
  commissionPercent: z8.coerce.number().min(0).max(50).default(0),
  active: z8.boolean().default(true)
});
var CONTENT_ERRORS = {
  SLUG_TAKEN: "SLUG_TAKEN",
  MENU_IN_USE: "MENU_IN_USE",
  REDIRECT_LOOP: "REDIRECT_LOOP",
  HANDLE_TAKEN: "HANDLE_TAKEN",
  NEWSLETTER_NOT_READY: "NEWSLETTER_NOT_READY"
};

// src/schemas/customer-admin.ts
import { z as z9 } from "zod";
var customerPatchSchema = z9.object({
  fullName: z9.string().trim().min(1).max(120).optional(),
  email: z9.string().trim().email().max(255).nullable().optional(),
  altPhone: z9.string().trim().max(20).nullable().optional(),
  locale: z9.enum(["fr", "ar", "en"]).optional(),
  groupId: idSchema.nullable().optional(),
  acceptsMarketing: z9.boolean().optional()
});
var customerNoteSchema = z9.object({
  body: z9.string().trim().min(1).max(2e3)
});
var blacklistSchema = z9.object({
  blacklisted: z9.boolean(),
  reason: z9.string().trim().max(255).nullable().optional()
}).refine((input) => !input.blacklisted || Boolean(input.reason?.trim()), {
  message: "Say why this customer is being blocked",
  path: ["reason"]
});
var customerMergeSchema = z9.object({
  keepId: idSchema,
  mergeId: idSchema
}).refine((input) => input.keepId !== input.mergeId, {
  message: "A customer cannot be merged into themselves",
  path: ["mergeId"]
});
var loyaltyAdjustSchema = z9.object({
  points: z9.coerce.number().int().min(-1e5).max(1e5),
  note: z9.string().trim().min(1).max(300)
}).refine((input) => input.points !== 0, {
  message: "An adjustment of zero points changes nothing",
  path: ["points"]
});
var customerGroupInputSchema = z9.object({
  name: translatedSchema,
  slug: z9.string().trim().min(2).max(48).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, "Lowercase words joined by hyphens"),
  discountPercent: z9.coerce.number().min(0).max(90).default(0)
});
var customerCreateSchema = z9.object({
  phone: dzPhoneSchema,
  fullName: z9.string().trim().min(1).max(120),
  email: z9.string().trim().email().max(255).nullable().optional(),
  groupId: idSchema.nullable().optional(),
  acceptsMarketing: z9.boolean().default(false)
});
var CUSTOMER_ERRORS = {
  PHONE_TAKEN: "PHONE_TAKEN",
  GROUP_IN_USE: "GROUP_IN_USE",
  MERGE_BLACKLISTED: "MERGE_BLACKLISTED",
  INSUFFICIENT_POINTS: "INSUFFICIENT_POINTS"
};

// src/schemas/delivery.ts
import { z as z10 } from "zod";
var shippingZoneInputSchema = z10.object({
  name: translatedSchema,
  wilayaCodes: z10.array(z10.coerce.number().int().min(1).max(58)).min(1).max(58),
  position: z10.coerce.number().int().min(0).max(999).default(0)
});
var shippingRateInputSchema = z10.object({
  zoneId: idSchema.nullable().optional(),
  wilayaCode: z10.coerce.number().int().min(1).max(58).nullable().optional(),
  courierId: idSchema.nullable().optional(),
  deliveryType: z10.nativeEnum(DeliveryType).default(DeliveryType.HOME),
  price: positiveMoneySchema,
  cost: positiveMoneySchema.default(0),
  freeWeightGrams: z10.coerce.number().int().min(0).max(1e5).default(1e3),
  extraPerKg: positiveMoneySchema.default(0),
  freeShippingThreshold: positiveMoneySchema.nullable().optional(),
  etaMinDays: z10.coerce.number().int().min(0).max(60).default(1),
  etaMaxDays: z10.coerce.number().int().min(0).max(60).default(4),
  active: z10.boolean().default(true)
}).refine((rate) => rate.zoneId != null || rate.wilayaCode != null, {
  message: "A rate covers either one wilaya or a zone",
  path: ["wilayaCode"]
}).refine((rate) => rate.etaMaxDays >= rate.etaMinDays, {
  message: "The longest estimate cannot be shorter than the shortest",
  path: ["etaMaxDays"]
});
var shippingRateBulkSchema = z10.object({
  cells: z10.array(
    z10.object({
      wilayaCode: z10.coerce.number().int().min(1).max(58),
      deliveryType: z10.nativeEnum(DeliveryType),
      courierId: idSchema.nullable().optional(),
      price: positiveMoneySchema,
      cost: positiveMoneySchema.optional(),
      active: z10.boolean().optional()
    })
  ).min(1).max(500)
});
var COURIER_PROVIDERS = ["manual", "yalidine", "zrexpress", "maystro", "ems"];
var COURIER_CREDENTIAL_FIELDS = {
  manual: [],
  yalidine: [
    { key: "apiId", label: "API ID", secret: false },
    { key: "apiToken", label: "API token", secret: true },
    { key: "fromWilayaId", label: "Wilaya de d\xE9part", secret: false, hint: "Code 1 \xE0 58" }
  ],
  zrexpress: [
    { key: "token", label: "Token", secret: true },
    { key: "key", label: "Cl\xE9", secret: true }
  ],
  maystro: [{ key: "apiKey", label: "Cl\xE9 API", secret: true }],
  ems: [
    { key: "accountNumber", label: "Num\xE9ro de compte", secret: false },
    { key: "password", label: "Mot de passe", secret: true }
  ]
};
var courierInputSchema = z10.object({
  name: z10.string().trim().min(1).max(120),
  slug: z10.string().trim().min(2).max(48).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, "Lowercase words joined by hyphens"),
  provider: z10.enum(COURIER_PROVIDERS).default("manual"),
  phone: z10.string().trim().max(20).nullable().optional(),
  email: z10.string().trim().email().max(255).nullable().optional(),
  codFeePercent: z10.coerce.number().min(0).max(100).default(0),
  settlementDays: z10.coerce.number().int().min(0).max(90).default(7),
  active: z10.boolean().default(true)
});
var courierCredentialsSchema = z10.object({
  values: z10.record(z10.string().max(64), z10.string().max(2e3))
});
var createShipmentSchema = z10.object({
  orderIds: z10.array(idSchema).min(1).max(100),
  courierId: idSchema.nullable().optional(),
  driverId: idSchema.nullable().optional(),
  note: z10.string().trim().max(400).optional()
}).refine((input) => Boolean(input.courierId) !== Boolean(input.driverId), {
  message: "A parcel goes to a courier or to one of our drivers, not both",
  path: ["courierId"]
});
var shipmentUpdateSchema = z10.object({
  trackingNumber: z10.string().trim().max(64).nullable().optional(),
  trackingUrl: z10.string().trim().url().max(400).nullable().optional(),
  cost: positiveMoneySchema.optional(),
  note: z10.string().trim().max(400).optional()
});
var trackingImportSchema = z10.object({
  rows: z10.array(
    z10.object({
      orderNumber: z10.string().trim().min(1).max(32),
      trackingNumber: z10.string().trim().min(1).max(64),
      status: z10.nativeEnum(ShipmentStatus).optional(),
      cost: positiveMoneySchema.optional()
    })
  ).min(1).max(1e3)
});
var VEHICLE_KINDS = ["van", "truck", "motorbike", "car"];
var vehicleInputSchema = z10.object({
  plate: z10.string().trim().min(3).max(24),
  label: z10.string().trim().min(1).max(120),
  kind: z10.enum(VEHICLE_KINDS).default("van"),
  capacityKg: z10.coerce.number().int().min(0).max(5e4).default(0),
  note: z10.string().trim().max(400).nullable().optional(),
  active: z10.boolean().default(true)
});
var driverInputSchema = z10.object({
  userId: idSchema.nullable().optional(),
  fullName: z10.string().trim().min(1).max(160).optional(),
  email: z10.string().trim().email().max(255).optional(),
  phone: dzPhoneSchema,
  wilayaCode: z10.coerce.number().int().min(1).max(58).nullable().optional(),
  licenseNo: z10.string().trim().max(48).nullable().optional(),
  active: z10.boolean().default(true)
});
var DELIVERY_RUN_STATUSES = ["PLANNED", "IN_PROGRESS", "COMPLETED", "CANCELLED"];
var STOP_STATUSES = [
  "PENDING",
  "ARRIVED",
  "DELIVERED",
  "FAILED",
  "RESCHEDULED"
];
var deliveryRunInputSchema = z10.object({
  date: z10.coerce.date(),
  driverId: idSchema,
  vehicleId: idSchema.nullable().optional(),
  note: z10.string().trim().max(500).nullable().optional()
});
var runAssignSchema = z10.object({
  orderIds: z10.array(idSchema).min(1).max(200)
});
var runReorderSchema = z10.object({
  stopIds: z10.array(idSchema).min(1).max(200)
});
var stopUpdateSchema = z10.object({
  status: z10.enum(STOP_STATUSES),
  cashCollected: positiveMoneySchema.optional(),
  failureReason: z10.nativeEnum(DeliveryFailureReason).nullable().optional(),
  note: z10.string().trim().max(400).nullable().optional(),
  proofMediaId: idSchema.nullable().optional()
}).refine((input) => input.status !== "FAILED" || Boolean(input.failureReason), {
  message: "Say why the delivery failed",
  path: ["failureReason"]
});
var cashReconcileSchema = z10.object({
  collectionIds: z10.array(idSchema).min(1).max(500),
  note: z10.string().trim().max(400).optional()
});
var SETTLEMENT_STATUSES = ["OPEN", "SENT", "PAID", "DISPUTED"];
var settlementGenerateSchema = z10.object({
  courierId: idSchema,
  from: z10.coerce.date(),
  to: z10.coerce.date()
}).refine((input) => input.to >= input.from, {
  message: "The period ends after it starts",
  path: ["to"]
});
var settlementPaySchema = z10.object({
  paidAmount: positiveMoneySchema,
  paidAt: z10.coerce.date().optional(),
  note: z10.string().trim().max(2e3).optional()
});
var DELIVERY_ERRORS = {
  NO_SHIPPING_RATE: "NO_SHIPPING_RATE",
  RATE_IN_USE: "RATE_IN_USE",
  ZONE_IN_USE: "ZONE_IN_USE",
  COURIER_NOT_READY: "COURIER_NOT_READY",
  COURIER_IN_USE: "COURIER_IN_USE",
  COURIER_REJECTED: "COURIER_REJECTED",
  ORDER_NOT_SHIPPABLE: "ORDER_NOT_SHIPPABLE",
  ALREADY_SHIPPED: "ALREADY_SHIPPED",
  SHIPMENT_NOT_CANCELLABLE: "SHIPMENT_NOT_CANCELLABLE",
  LABEL_UNAVAILABLE: "LABEL_UNAVAILABLE",
  RUN_NOT_EDITABLE: "RUN_NOT_EDITABLE",
  RUN_CLOSED: "RUN_CLOSED",
  STOP_ALREADY_CLOSED: "STOP_ALREADY_CLOSED",
  DRIVER_BUSY: "DRIVER_BUSY",
  DRIVER_HAS_RUNS: "DRIVER_HAS_RUNS",
  VEHICLE_IN_USE: "VEHICLE_IN_USE",
  SETTLEMENT_EMPTY: "SETTLEMENT_EMPTY",
  SETTLEMENT_LOCKED: "SETTLEMENT_LOCKED",
  WEBHOOK_SIGNATURE: "WEBHOOK_SIGNATURE"
};

// src/schemas/finance.ts
import { z as z11 } from "zod";
var EXPENSE_RECURRENCES = ["monthly", "weekly", "yearly"];
var expenseCategoryInputSchema = z11.object({
  name: translatedSchema,
  slug: z11.string().trim().min(2).max(48).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, "Lowercase words joined by hyphens"),
  color: z11.string().regex(/^#[0-9a-fA-F]{6}$/, "A hex colour, like #B8860B").nullable().optional()
});
var expenseInputSchema = z11.object({
  categoryId: idSchema.nullable().optional(),
  label: z11.string().trim().min(1).max(200),
  amount: positiveMoneySchema,
  incurredAt: z11.coerce.date(),
  recurrence: z11.enum(EXPENSE_RECURRENCES).nullable().optional(),
  recurrenceEndsAt: z11.coerce.date().nullable().optional(),
  attachmentKey: z11.string().trim().max(400).nullable().optional(),
  note: z11.string().trim().max(2e3).nullable().optional()
}).refine(
  (input) => !input.recurrenceEndsAt || input.recurrenceEndsAt >= input.incurredAt,
  { message: "A series cannot end before it starts", path: ["recurrenceEndsAt"] }
);
var AD_PLATFORMS = ["facebook", "instagram", "tiktok", "google", "other"];
var adSpendInputSchema = z11.object({
  platform: z11.enum(AD_PLATFORMS),
  campaign: z11.string().trim().max(160).nullable().optional(),
  spentOn: z11.coerce.date(),
  amount: positiveMoneySchema,
  impressions: z11.coerce.number().int().min(0).nullable().optional(),
  clicks: z11.coerce.number().int().min(0).nullable().optional(),
  note: z11.string().trim().max(400).nullable().optional()
});
var LEDGER_KINDS = [
  "sale",
  "cod_collection",
  "refund",
  "expense",
  "settlement",
  "adjustment"
];
var LEDGER_ACCOUNTS = ["cash", "bank", "courier", "customer"];
var ledgerEntryInputSchema = z11.object({
  kind: z11.enum(LEDGER_KINDS),
  account: z11.enum(LEDGER_ACCOUNTS),
  /** Signed: positive is money in, negative is money out. */
  amount: moneyAmountSchema,
  orderId: idSchema.nullable().optional(),
  occurredAt: z11.coerce.date().optional(),
  note: z11.string().trim().max(400).nullable().optional()
});
var PNL_GROUPINGS = [
  "day",
  "week",
  "month",
  "product",
  "category",
  "collection",
  "wilaya",
  "channel",
  "courier"
];
var pnlQuerySchema = z11.object({
  from: z11.coerce.date(),
  to: z11.coerce.date(),
  groupBy: z11.enum(PNL_GROUPINGS).default("day"),
  /** Adds the same span immediately before, for comparison. */
  compare: z11.coerce.boolean().default(false),
  format: z11.enum(["csv", "xlsx"]).optional()
});
var REPORT_KEYS = [
  "sales.by_product",
  "sales.by_variant",
  "sales.by_category",
  "sales.by_collection",
  "sales.by_period",
  "sales.by_wilaya",
  "sales.by_courier",
  "sales.by_source",
  "sales.by_agent",
  "inventory.valuation",
  "inventory.ageing",
  "inventory.stockouts",
  "customers.cohorts",
  "customers.retention",
  "promotions.performance",
  "search.zero_results",
  "funnel.conversion"
];
var reportQuerySchema = z11.object({
  from: z11.coerce.date().optional(),
  to: z11.coerce.date().optional(),
  limit: z11.coerce.number().int().min(1).max(500).default(50),
  format: z11.enum(["csv", "xlsx"]).optional()
});
var reportExportRequestSchema = z11.object({
  from: z11.coerce.date(),
  to: z11.coerce.date(),
  format: z11.enum(["csv", "xlsx"]).default("xlsx")
});
var REPORT_EXPORT_STATUSES = ["pending", "running", "ready", "failed"];
var FINANCE_ERRORS = {
  CATEGORY_IN_USE: "CATEGORY_IN_USE",
  EXPENSE_LOCKED: "EXPENSE_LOCKED",
  PERIOD_TOO_LONG: "PERIOD_TOO_LONG",
  UNKNOWN_REPORT: "UNKNOWN_REPORT",
  EXPORT_NOT_READY: "EXPORT_NOT_READY"
};
var MAX_REPORT_DAYS = 400;

// src/schemas/inventory.ts
import { z as z12 } from "zod";
var locationInputSchema = z12.object({
  name: z12.string().trim().min(1).max(120),
  code: z12.string().trim().min(2).max(24).regex(/^[A-Z0-9][A-Z0-9-]*$/, "Codes are uppercase letters, digits and hyphens"),
  address: z12.string().trim().max(400).optional(),
  wilayaCode: z12.coerce.number().int().min(1).max(58).optional(),
  isDefault: z12.boolean().default(false),
  active: z12.boolean().default(true)
});
var STOCK_FILTER_STATES = ["in", "low", "out", "negative"];
var stockAdjustSchema = z12.object({
  variantId: idSchema,
  locationId: idSchema,
  /** Signed delta, or the absolute target when mode is "set". */
  quantity: z12.coerce.number().int(),
  mode: z12.enum(["delta", "set"]).default("delta"),
  reason: z12.enum([
    StockMovementReason.ADJUSTMENT,
    StockMovementReason.DAMAGED,
    StockMovementReason.RETURN,
    StockMovementReason.STOCK_COUNT,
    StockMovementReason.PURCHASE
  ]).default(StockMovementReason.ADJUSTMENT),
  note: z12.string().trim().max(400).optional()
});
var stockTransferSchema = z12.object({
  variantId: idSchema,
  fromLocationId: idSchema,
  toLocationId: idSchema,
  quantity: z12.coerce.number().int().min(1),
  note: z12.string().trim().max(400).optional()
}).refine((input) => input.fromLocationId !== input.toLocationId, {
  message: "Choose two different locations",
  path: ["toLocationId"]
});
var stockBulkAdjustSchema = z12.object({
  locationId: idSchema,
  reason: stockAdjustSchema.shape.reason,
  note: z12.string().trim().max(400).optional(),
  lines: z12.array(z12.object({ variantId: idSchema, quantity: z12.coerce.number().int() })).min(1).max(500)
});
var supplierInputSchema = z12.object({
  name: z12.string().trim().min(1).max(160),
  contactName: z12.string().trim().max(120).optional(),
  phone: z12.string().trim().max(20).optional(),
  email: z12.union([z12.string().trim().email().max(255), z12.literal("")]).optional(),
  address: z12.string().trim().max(400).optional(),
  note: z12.string().trim().max(4e3).optional(),
  active: z12.boolean().default(true)
});
var purchaseOrderItemInputSchema = z12.object({
  variantId: idSchema,
  quantity: z12.coerce.number().int().min(1).max(1e5),
  unitCost: positiveMoneySchema
});
var purchaseOrderInputSchema = z12.object({
  supplierId: idSchema,
  locationId: idSchema,
  expectedAt: z12.coerce.date().optional(),
  shippingCost: positiveMoneySchema.default(0),
  otherCost: positiveMoneySchema.default(0),
  note: z12.string().trim().max(4e3).optional(),
  items: z12.array(purchaseOrderItemInputSchema).min(1, "A purchase order needs at least one line")
});
var purchaseOrderPatchSchema = purchaseOrderInputSchema.partial();
var purchaseOrderReceiveSchema = z12.object({
  lines: z12.array(
    z12.object({
      itemId: idSchema,
      quantity: z12.coerce.number().int().min(0).max(1e5),
      /** Overrides the ordered unit cost when the invoice differs. */
      unitCost: positiveMoneySchema.optional()
    })
  ).min(1),
  note: z12.string().trim().max(400).optional()
});
var stockCountStartSchema = z12.object({
  locationId: idSchema,
  name: z12.string().trim().min(1).max(120),
  /** Empty means every variant that has a level at this location. */
  variantIds: z12.array(idSchema).max(5e3).optional(),
  categoryId: idSchema.optional(),
  note: z12.string().trim().max(4e3).optional()
});
var stockCountEntrySchema = z12.object({
  lines: z12.array(
    z12.object({
      itemId: idSchema,
      countedQuantity: z12.coerce.number().int().min(0).max(1e6).nullable()
    })
  ).min(1).max(1e3)
});
var STOCK_COUNT_STATUSES = ["OPEN", "APPLIED", "CANCELLED"];
var INVENTORY_ERRORS = {
  LOCATION_IN_USE: "LOCATION_IN_USE",
  LAST_LOCATION: "LAST_LOCATION",
  INSUFFICIENT_STOCK: "INSUFFICIENT_STOCK",
  PO_NOT_EDITABLE: "PO_NOT_EDITABLE",
  PO_NOT_RECEIVABLE: "PO_NOT_RECEIVABLE",
  RECEIVE_OVER_ORDERED: "RECEIVE_OVER_ORDERED",
  COUNT_CLOSED: "COUNT_CLOSED",
  SUPPLIER_IN_USE: "SUPPLIER_IN_USE"
};

// src/schemas/media.ts
import { z as z13 } from "zod";
var MAX_IMAGE_BYTES = 20 * 1024 * 1024;
var MAX_VIDEO_BYTES = 200 * 1024 * 1024;
var MAX_MODEL_BYTES = 15 * 1024 * 1024;
var MAX_DOCUMENT_BYTES = 20 * 1024 * 1024;
var ACCEPTED_MIME_TYPES = {
  IMAGE: ["image/jpeg", "image/png", "image/webp", "image/avif", "image/gif", "image/svg+xml"],
  VIDEO: ["video/mp4", "video/webm"],
  MODEL_3D: ["model/gltf-binary"],
  DOCUMENT: ["application/pdf"]
};
var MAX_BYTES_BY_KIND = {
  IMAGE: MAX_IMAGE_BYTES,
  VIDEO: MAX_VIDEO_BYTES,
  MODEL_3D: MAX_MODEL_BYTES,
  DOCUMENT: MAX_DOCUMENT_BYTES
};
var UPLOAD_ACCEPT = [
  ...ACCEPTED_MIME_TYPES.IMAGE,
  ...ACCEPTED_MIME_TYPES.VIDEO,
  ...ACCEPTED_MIME_TYPES.DOCUMENT,
  ".glb"
].join(",");
var RENDITION_WIDTHS = { thumb: 200, card: 600, zoom: 1600 };
var RENDITION_FORMATS = ["webp", "avif"];
function pickRendition(renditions, minWidth, format2 = "webp") {
  if (!renditions || renditions.length === 0) return null;
  const candidates = renditions.filter((rendition) => rendition.format === format2).sort((a, b) => a.width - b.width);
  if (candidates.length === 0) return null;
  return candidates.find((rendition) => rendition.width >= minWidth) ?? candidates.at(-1) ?? null;
}
function buildSrcSet(renditions, toUrl, format2 = "webp") {
  const entries = (renditions ?? []).filter((rendition) => rendition.format === format2).sort((a, b) => a.width - b.width).map((rendition) => `${toUrl(rendition.key)} ${rendition.width}w`);
  return entries.length > 0 ? entries.join(", ") : void 0;
}
var mediaListQuerySchema = adminListQuerySchema.extend({
  kind: z13.nativeEnum(MediaKind).optional(),
  folderId: z13.string().optional(),
  /** `true` returns only files nothing references, for a safe clean-up. */
  unusedOnly: z13.coerce.boolean().optional()
});
var mediaPatchSchema = z13.object({
  alt: translatedOptionalSchema.optional(),
  folderId: idSchema.nullable().optional(),
  fileName: z13.string().trim().min(1).max(255).optional(),
  /** Assigns a poster image to a 3D model or a video. */
  posterMediaId: idSchema.nullable().optional()
});
var mediaFolderInputSchema = z13.object({
  name: z13.string().trim().min(1).max(120),
  parentId: idSchema.nullable().optional()
});
var mediaUploadFieldsSchema = z13.object({
  folderId: idSchema.optional(),
  alt: z13.string().max(2e3).optional()
});
var MEDIA_ERRORS = {
  UNSUPPORTED_TYPE: "That file type is not accepted",
  FILE_TOO_LARGE: "That file is too large",
  CONTENT_MISMATCH: "The file contents do not match its extension",
  MEDIA_IN_USE: "That file is still used somewhere and cannot be deleted",
  FOLDER_NOT_EMPTY: "Empty the folder before deleting it"
};

// src/schemas/order.ts
import { z as z14 } from "zod";
var orderTransitionSchema = z14.object({
  to: z14.nativeEnum(OrderStatus),
  reason: z14.string().trim().max(500).optional(),
  failureReason: z14.nativeEnum(DeliveryFailureReason).optional(),
  /** Cash handed over by the customer, in centimes, when moving to DELIVERED. */
  cashCollected: positiveMoneySchema.optional(),
  metadata: z14.record(z14.unknown()).optional()
});
var callLogSchema = z14.object({
  outcome: z14.nativeEnum(CallOutcome),
  note: z14.string().trim().max(1e3).optional(),
  callBackAt: z14.coerce.date().optional()
});
var manualOrderSchema = z14.object({
  customer: z14.object({
    id: idSchema.optional(),
    fullName: z14.string().trim().min(3).max(120),
    phone: dzPhoneSchema,
    altPhone: dzPhoneSchema.optional()
  }),
  items: z14.array(
    z14.object({
      variantId: idSchema,
      quantity: z14.coerce.number().int().min(1).max(100),
      unitPriceOverride: positiveMoneySchema.optional()
    })
  ).min(1, "Add at least one item"),
  shipping: z14.object({
    wilayaCode: z14.coerce.number().int().min(1).max(58),
    communeId: idSchema,
    deliveryType: z14.nativeEnum(DeliveryType),
    address: z14.string().trim().max(400).optional(),
    pickupPointId: idSchema.optional(),
    feeOverride: positiveMoneySchema.optional()
  }),
  payment: z14.object({ method: z14.nativeEnum(PaymentMethod).default(PaymentMethod.COD) }),
  source: z14.nativeEnum(OrderSource).default(OrderSource.PHONE),
  promoCode: z14.string().trim().max(48).optional(),
  discountOverride: positiveMoneySchema.optional(),
  note: z14.string().trim().max(1e3).optional()
});
var editOrderItemsSchema = z14.object({
  items: z14.array(
    z14.object({
      id: idSchema.optional(),
      variantId: idSchema,
      quantity: z14.coerce.number().int().min(0).max(100),
      unitPriceOverride: positiveMoneySchema.optional()
    })
  ),
  reason: z14.string().trim().max(500).optional()
});
var returnRequestSchema = z14.object({
  orderId: idSchema,
  items: z14.array(
    z14.object({
      orderItemId: idSchema,
      quantity: z14.coerce.number().int().min(1),
      condition: z14.nativeEnum(ReturnCondition).default(ReturnCondition.RESELLABLE),
      reason: z14.string().trim().max(300).optional()
    })
  ).min(1),
  restock: z14.boolean().default(true),
  refundAmount: positiveMoneySchema.optional(),
  note: z14.string().trim().max(1e3).optional()
});
var orderListQuerySchema = z14.object({
  status: z14.array(z14.nativeEnum(OrderStatus)).or(z14.nativeEnum(OrderStatus)).optional(),
  q: z14.string().trim().max(120).optional(),
  wilayaCode: z14.coerce.number().int().min(1).max(58).optional(),
  courierId: idSchema.optional(),
  driverId: idSchema.optional(),
  agentId: idSchema.optional(),
  paymentMethod: z14.nativeEnum(PaymentMethod).optional(),
  source: z14.nativeEnum(OrderSource).optional(),
  tag: z14.string().max(64).optional(),
  from: z14.coerce.date().optional(),
  to: z14.coerce.date().optional(),
  page: z14.coerce.number().int().min(1).default(1),
  perPage: z14.coerce.number().int().min(1).max(200).default(50),
  sortBy: z14.enum(["createdAt", "total", "number", "status"]).default("createdAt"),
  sortDir: z14.enum(["asc", "desc"]).default("desc")
});
var RISK_FLAGS = [
  "BLACKLISTED",
  "FAILED_HISTORY",
  "MANY_CANCELLATIONS",
  "DUPLICATE_ORDER",
  "ORDER_FLOOD",
  "IP_FLOOD",
  "UNUSUALLY_LARGE",
  "PHONE_UNVERIFIED",
  "VAGUE_ADDRESS",
  "FIRST_ORDER"
];
var orderDocumentBatchSchema = z14.object({
  kind: z14.enum(["invoice", "packing-slip"]),
  orderIds: z14.array(z14.string().uuid()).min(1).max(200)
});

// src/schemas/order-admin.ts
import { z as z15 } from "zod";
var orderNoteSchema = z15.object({
  body: z15.string().trim().min(1).max(2e3)
});
var orderTagsSchema = z15.object({
  tags: z15.array(z15.string().trim().min(1).max(48)).max(20)
});
var orderAddressPatchSchema = z15.object({
  customerName: z15.string().trim().min(2).max(120).optional(),
  customerPhone: z15.string().trim().min(9).max(20).optional(),
  customerAltPhone: z15.string().trim().max(20).nullable().optional(),
  wilayaCode: z15.coerce.number().int().min(1).max(58).optional(),
  communeId: idSchema.optional(),
  address: z15.string().trim().max(400).nullable().optional(),
  pickupPointId: idSchema.nullable().optional(),
  note: z15.string().trim().max(500).nullable().optional(),
  internalNote: z15.string().trim().max(4e3).nullable().optional()
});
var orderBulkSchema = z15.object({
  ids: z15.array(idSchema).min(1).max(200),
  action: z15.enum(["confirm", "pack", "ship", "cancel"]),
  reason: z15.string().trim().max(500).optional()
});
var ORDER_ERRORS = {
  ILLEGAL_TRANSITION: "ILLEGAL_TRANSITION",
  NOT_EDITABLE: "NOT_EDITABLE",
  ORDER_BLOCKED: "ORDER_BLOCKED",
  CAPTCHA_REQUIRED: "CAPTCHA_REQUIRED",
  COMMUNE_MISMATCH: "COMMUNE_MISMATCH",
  RETURN_TOO_MANY: "RETURN_TOO_MANY"
};

// src/schemas/promotion.ts
import { z as z16 } from "zod";
var promotionConditionSchema = z16.object({
  minSubtotal: positiveMoneySchema.optional(),
  minQuantity: z16.coerce.number().int().min(1).optional(),
  productIds: z16.array(idSchema).default([]),
  variantIds: z16.array(idSchema).default([]),
  collectionIds: z16.array(idSchema).default([]),
  categoryIds: z16.array(idSchema).default([]),
  customerGroupIds: z16.array(idSchema).default([]),
  wilayaCodes: z16.array(z16.coerce.number().int().min(1).max(58)).default([]),
  firstOrderOnly: z16.boolean().default(false)
});
var buyXGetYSchema = z16.object({
  buyQuantity: z16.coerce.number().int().min(1),
  getQuantity: z16.coerce.number().int().min(1),
  /** 100 means the free item is free; 50 means half price on the Y items. */
  getDiscountPercent: z16.coerce.number().min(0).max(100).default(100)
});
var tierSchema = z16.object({
  minSubtotal: positiveMoneySchema,
  percentOff: z16.coerce.number().min(0).max(100)
});
var promotionInputSchema = z16.object({
  name: z16.string().trim().min(2).max(120),
  description: z16.string().trim().max(500).optional(),
  type: z16.nativeEnum(PromotionType),
  scope: z16.nativeEnum(PromotionScope).default(PromotionScope.ORDER),
  /** null = automatic promotion with no code (F-AD-20). */
  code: z16.string().trim().min(2).max(48).regex(/^[A-Z0-9_-]+$/, "Codes are upper case letters, digits, dash and underscore").nullable().optional(),
  percentOff: z16.coerce.number().min(0).max(100).optional(),
  amountOff: positiveMoneySchema.optional(),
  bundlePrice: positiveMoneySchema.optional(),
  buyXGetY: buyXGetYSchema.optional(),
  tiers: z16.array(tierSchema).default([]),
  conditions: promotionConditionSchema.default({
    productIds: [],
    variantIds: [],
    collectionIds: [],
    categoryIds: [],
    customerGroupIds: [],
    wilayaCodes: [],
    firstOrderOnly: false
  }),
  usageLimitTotal: z16.coerce.number().int().min(1).nullable().optional(),
  usageLimitPerCustomer: z16.coerce.number().int().min(1).nullable().optional(),
  stackable: z16.boolean().default(false),
  priority: z16.coerce.number().int().min(0).max(1e3).default(100),
  startsAt: z16.coerce.date().nullable().optional(),
  endsAt: z16.coerce.date().nullable().optional(),
  active: z16.boolean().default(true),
  showCountdown: z16.boolean().default(false)
}).superRefine((value, ctx) => {
  const need = (field) => {
    const present = field === "tiers" ? value.tiers.length > 0 : value[field] !== void 0 && value[field] !== null;
    if (!present) {
      ctx.addIssue({
        code: z16.ZodIssueCode.custom,
        path: [field],
        message: `${value.type} promotions require ${field}`
      });
    }
  };
  if (value.type === PromotionType.PERCENTAGE) need("percentOff");
  if (value.type === PromotionType.FIXED_AMOUNT) need("amountOff");
  if (value.type === PromotionType.BUNDLE_PRICE) need("bundlePrice");
  if (value.type === PromotionType.BUY_X_GET_Y) need("buyXGetY");
  if (value.type === PromotionType.TIERED) need("tiers");
  if (value.startsAt && value.endsAt && value.startsAt >= value.endsAt) {
    ctx.addIssue({
      code: z16.ZodIssueCode.custom,
      path: ["endsAt"],
      message: "The end date must come after the start date"
    });
  }
});
var bulkCodeSchema = z16.object({
  promotionId: idSchema,
  count: z16.coerce.number().int().min(1).max(5e3),
  prefix: z16.string().trim().max(12).regex(/^[A-Z0-9]*$/).default(""),
  length: z16.coerce.number().int().min(4).max(16).default(8),
  usageLimitPerCode: z16.coerce.number().int().min(1).default(1)
});
var promotionSimulateSchema = z16.object({
  variantIds: z16.array(z16.object({ variantId: idSchema, quantity: z16.coerce.number().int().min(1).max(99) })).max(50),
  codes: z16.array(z16.string().trim().max(48)).max(5).default([]),
  wilayaCode: z16.coerce.number().int().min(1).max(58).nullable().optional(),
  customerId: idSchema.nullable().optional(),
  shippingMinor: z16.string().regex(/^d+$/).default("0")
});
var PROMO_REJECTIONS = {
  NOT_FOUND: "This code does not exist",
  INACTIVE: "This code is no longer active",
  NOT_STARTED: "This code is not valid yet",
  EXPIRED: "This code has expired",
  USAGE_LIMIT_REACHED: "This code has reached its usage limit",
  CUSTOMER_LIMIT_REACHED: "You have already used this code",
  MIN_SUBTOTAL: "Your cart has not reached the minimum amount for this code",
  MIN_QUANTITY: "Add more items to use this code",
  NOT_ELIGIBLE: "This code does not apply to the items in your cart",
  WILAYA_NOT_ELIGIBLE: "This code is not available in your wilaya",
  FIRST_ORDER_ONLY: "This code is for first orders only",
  NOT_STACKABLE: "This code cannot be combined with the discount already applied"
};

// src/schemas/storefront.ts
import { z as z17 } from "zod";
var wishlistItemSchema = z17.object({
  productId: idSchema,
  variantId: idSchema.nullable().optional()
});
var notifyMeSchema = z17.object({
  productId: idSchema,
  variantId: idSchema.nullable().optional(),
  phone: dzPhoneSchema.optional(),
  email: emailSchema.optional()
}).refine((input) => Boolean(input.phone || input.email), {
  message: "Leave a phone number or an e-mail so we can reach you",
  path: ["phone"]
});
var reviewSubmitSchema = z17.object({
  productId: idSchema,
  rating: z17.coerce.number().int().min(1).max(5),
  title: z17.string().trim().max(120).optional(),
  body: z17.string().trim().min(10, "Tell us a little more").max(2e3),
  authorName: z17.string().trim().min(2).max(80),
  /** Used to check for a delivered order, and never published. */
  phone: dzPhoneSchema.optional(),
  email: emailSchema.optional()
});
var newsletterSchema = z17.object({
  email: emailSchema.optional(),
  phone: dzPhoneSchema.optional(),
  locale: z17.enum(["fr", "ar", "en"]).default("fr"),
  source: z17.string().trim().max(48).optional()
}).refine((input) => Boolean(input.email || input.phone), {
  message: "Enter an e-mail address or a phone number",
  path: ["email"]
});
var contactSchema = z17.object({
  name: z17.string().trim().min(2).max(120),
  email: emailSchema.optional(),
  phone: dzPhoneSchema.optional(),
  subject: z17.string().trim().max(200).optional(),
  body: z17.string().trim().min(10).max(4e3)
});
var ANALYTICS_EVENT_NAMES = [
  "page_view",
  "product_view",
  "collection_view",
  "search",
  "add_to_cart",
  "remove_from_cart",
  "view_cart",
  "checkout_start",
  "checkout_step",
  "purchase",
  "wishlist_add"
];
var analyticsEventSchema = z17.object({
  name: z17.enum(ANALYTICS_EVENT_NAMES),
  /** Random per browser session; never a customer identifier. */
  sessionId: z17.string().trim().min(8).max(64),
  productId: idSchema.optional(),
  variantId: idSchema.optional(),
  orderId: idSchema.optional(),
  path: z17.string().trim().max(400).optional(),
  referrer: z17.string().trim().max(400).optional(),
  utmSource: z17.string().trim().max(120).optional(),
  utmMedium: z17.string().trim().max(120).optional(),
  utmCampaign: z17.string().trim().max(120).optional(),
  query: z17.string().trim().max(200).optional(),
  resultCount: z17.coerce.number().int().min(0).max(1e5).optional(),
  valueMinor: z17.coerce.number().int().min(0).optional(),
  device: z17.enum(["mobile", "tablet", "desktop"]).optional(),
  wilayaCode: z17.coerce.number().int().min(1).max(58).optional(),
  occurredAt: z17.coerce.date().optional()
});
var analyticsBatchSchema = z17.object({
  events: z17.array(analyticsEventSchema).min(1).max(50)
});
var addressInputSchema = z17.object({
  label: z17.string().trim().max(48).optional(),
  fullName: z17.string().trim().min(2).max(120),
  phone: dzPhoneSchema,
  altPhone: dzPhoneSchema.optional(),
  wilayaCode: z17.coerce.number().int().min(1).max(58),
  communeId: idSchema,
  address: z17.string().trim().min(5).max(400),
  isDefault: z17.boolean().default(false)
});
var trackOrderSchema = z17.object({
  number: z17.string().trim().min(4).max(32).toUpperCase(),
  phone: dzPhoneSchema
});
var STOREFRONT_ERRORS = {
  ALREADY_SUBSCRIBED: "ALREADY_SUBSCRIBED",
  REVIEW_DUPLICATE: "REVIEW_DUPLICATE",
  ORDER_NOT_FOUND: "ORDER_NOT_FOUND",
  NOT_A_CUSTOMER: "NOT_A_CUSTOMER"
};

// src/schemas/system.ts
import { z as z18 } from "zod";
var SETTING_SCOPES = [
  "store",
  "localisation",
  "tax",
  "orders",
  "checkout",
  "loyalty",
  "inventory",
  "theme",
  "integrations",
  "notifications",
  "payments",
  "couriers",
  "maintenance"
];
var hexColor = z18.string().regex(/^#[0-9a-fA-F]{6}$/, "Use a hex colour like #D9B36A");
var settingScopeSchemas = {
  store: z18.object({
    "store.name": z18.string().trim().min(1).max(120),
    "store.legal_name": z18.string().trim().max(160),
    "store.email": emailSchema,
    "store.phones": z18.array(z18.string().trim().min(6).max(20)).max(5),
    "store.address": z18.string().trim().max(400),
    "store.rc": z18.string().trim().max(40),
    "store.nif": z18.string().trim().max(40),
    // Article d'imposition. Printed on an invoice beside the RC and the NIF; a shop
    // without one leaves it blank and the line is omitted rather than left empty.
    "store.art": z18.string().trim().max(40),
    "store.currency": z18.enum(["DZD"])
  }),
  localisation: z18.object({
    "store.timezone": z18.string().trim().min(3).max(64),
    "store.locales": z18.array(z18.enum(["fr", "ar", "en"])).min(1),
    "store.default_locale": z18.enum(["fr", "ar", "en"])
  }),
  tax: z18.object({
    "tax.vat_percent": z18.coerce.number().min(0).max(100),
    "tax.prices_include_tax": z18.boolean()
  }),
  orders: z18.object({
    /** DECISIONS D20 — when stock leaves the shelf in the eyes of the ledger. */
    "orders.stock_deduction_moment": z18.enum(["confirmed", "packed", "shipped", "delivered"]),
    "orders.number_format": z18.string().trim().min(3).max(48),
    "orders.auto_confirm": z18.boolean(),
    "orders.duplicate_window_minutes": z18.coerce.number().int().min(0).max(1440),
    "orders.max_per_phone_per_day": z18.coerce.number().int().min(1).max(50),
    "orders.captcha_after_attempts": z18.coerce.number().int().min(1).max(20),
    "orders.require_otp": z18.boolean()
  }),
  checkout: z18.object({
    /** Minor units. Zero disables the free-shipping bar entirely. */
    "checkout.free_shipping_threshold": z18.coerce.number().int().min(0),
    "checkout.allow_guest": z18.boolean(),
    "checkout.collect_email": z18.boolean(),
    "checkout.second_phone": z18.boolean()
  }),
  loyalty: z18.object({
    "loyalty.enabled": z18.boolean(),
    "loyalty.points_per_currency_unit": z18.coerce.number().min(0).max(10),
    "loyalty.point_value_centimes": z18.coerce.number().int().min(0),
    "loyalty.max_order_percent": z18.coerce.number().min(0).max(100)
  }),
  inventory: z18.object({
    "inventory.low_stock_threshold": z18.coerce.number().int().min(0).max(1e4),
    "inventory.allow_backorder": z18.boolean()
  }),
  theme: z18.object({
    "theme.primary_color": hexColor,
    "theme.base_color": hexColor,
    "theme.surface_color": hexColor,
    "theme.logo_media_id": idSchema.nullable().optional(),
    "theme.favicon_media_id": idSchema.nullable().optional(),
    "theme.hero_model_media_id": idSchema.nullable().optional()
  }),
  integrations: z18.object({
    "integrations.ga4_id": z18.string().trim().max(40),
    "integrations.meta_pixel_id": z18.string().trim().max(40),
    "integrations.tiktok_pixel_id": z18.string().trim().max(40),
    "integrations.cookie_banner": z18.boolean()
  }),
  notifications: z18.object({
    "notifications.sms_driver": z18.enum(["log", "twilio", "http", "whatsapp"]),
    "notifications.sms_endpoint": z18.string().trim().max(400).optional(),
    "notifications.sms_credentials": z18.string().max(2e3).optional(),
    "notifications.email_driver": z18.enum(["log", "smtp"]),
    /** Where a new order is e-mailed to the shop. Empty switches it off. */
    "notifications.owner_email": z18.union([z18.literal(""), z18.string().trim().email().max(255)]).optional(),
    "notifications.telegram_enabled": z18.boolean(),
    "notifications.telegram_token": z18.string().max(200).optional(),
    "notifications.telegram_chat_id": z18.string().max(64).optional(),
    "notifications.owner_alerts": z18.array(z18.string().max(64)).max(30)
  }),
  payments: z18.object({
    "payments.default_provider": z18.enum(["cod", "chargily"]),
    "payments.cod_enabled": z18.boolean(),
    "payments.chargily_enabled": z18.boolean(),
    "payments.chargily_api_key": z18.string().max(200).optional(),
    "payments.chargily_secret": z18.string().max(200).optional(),
    /** Minor units taken up front on a COD order; zero means none. */
    "payments.cod_deposit_minor": z18.coerce.number().int().min(0)
  }),
  couriers: z18.object({
    "couriers.default_provider": z18.string().trim().max(40),
    "couriers.auto_create_shipment": z18.boolean(),
    "couriers.sync_interval_minutes": z18.coerce.number().int().min(5).max(1440)
  }),
  maintenance: z18.object({
    "store.maintenance_mode": z18.boolean(),
    "store.maintenance_message": z18.string().trim().max(400).optional()
  })
};
var SECRET_SETTING_KEYS = [
  "notifications.sms_credentials",
  "notifications.telegram_token",
  "payments.chargily_api_key",
  "payments.chargily_secret"
];
var SECRET_MASK = "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022";
var NOTIFICATION_EVENTS = [
  "order.placed",
  "order.confirmed",
  "order.shipped",
  "order.out_for_delivery",
  "order.delivered",
  "order.failed",
  "order.cancelled",
  "stock.back_in_stock",
  "cart.abandoned",
  "review.request",
  "inventory.low",
  "owner.new_order",
  "auth.otp"
];
var notificationTemplateSchema = z18.object({
  event: z18.string().trim().min(3).max(64),
  channel: z18.enum([
    NotificationChannel.SMS,
    NotificationChannel.EMAIL,
    NotificationChannel.WHATSAPP,
    NotificationChannel.TELEGRAM,
    NotificationChannel.IN_APP
  ]),
  subject: z18.object({
    fr: z18.string().max(200),
    ar: z18.string().max(200).optional(),
    en: z18.string().max(200).optional()
  }).optional(),
  body: z18.object({
    fr: z18.string().min(1).max(4e3),
    ar: z18.string().max(4e3).optional(),
    en: z18.string().max(4e3).optional()
  }),
  active: z18.boolean().default(true)
});
var templateTestSchema = z18.object({
  /** Phone or e-mail, depending on the channel. */
  recipient: z18.string().trim().min(3).max(255),
  locale: z18.enum(["fr", "ar", "en"]).default("fr")
});
var TEMPLATE_VARIABLES = {
  "order.placed": ["customerName", "orderNumber", "total", "trackingUrl", "storeName"],
  "order.confirmed": ["customerName", "orderNumber", "total", "trackingUrl", "storeName"],
  "order.shipped": ["customerName", "orderNumber", "courier", "trackingNumber", "trackingUrl"],
  "order.out_for_delivery": ["customerName", "orderNumber", "driverName", "driverPhone"],
  "order.delivered": ["customerName", "orderNumber", "total", "storeName"],
  "order.failed": ["customerName", "orderNumber", "reason", "storePhone"],
  "order.cancelled": ["customerName", "orderNumber", "reason"],
  "stock.back_in_stock": ["customerName", "productName", "productUrl"],
  "cart.abandoned": ["customerName", "cartUrl", "total", "promoCode"],
  "review.request": ["customerName", "orderNumber", "productName", "reviewUrl"],
  "inventory.low": ["productName", "sku", "available", "locationName"],
  "owner.new_order": [
    "orderNumber",
    "total",
    "wilaya",
    "customerPhone",
    "customerFullName",
    "commune",
    "deliveryLine",
    "items",
    "shipping",
    "noteBlock",
    "orderLink"
  ],
  "auth.otp": ["code", "storeName", "minutes"]
};
var staffInviteSchema = z18.object({
  name: z18.string().trim().min(2).max(120),
  email: emailSchema,
  roleId: idSchema
});
var staffUpdateSchema = z18.object({
  name: z18.string().trim().min(2).max(120).optional(),
  email: emailSchema.optional(),
  phone: dzPhoneSchema.optional(),
  locale: z18.enum(["fr", "ar", "en"]).optional(),
  active: z18.boolean().optional(),
  roleIds: z18.array(idSchema).max(10).optional()
});
var staffPasswordSchema = z18.object({
  password: z18.string().min(10, "Use at least 10 characters").max(200).regex(/[a-z]/, "Include a lowercase letter").regex(/[A-Z]/, "Include an uppercase letter").regex(/\d/, "Include a digit")
});
var acceptInvitationSchema = z18.object({
  token: z18.string().min(20).max(200),
  password: staffPasswordSchema.shape.password
});
var roleInputSchema = z18.object({
  slug: z18.string().trim().min(2).max(48).regex(/^[a-z][a-z0-9_]*$/, "Role keys are lowercase words joined by underscores"),
  name: translatedSchema,
  description: z18.string().trim().max(255).optional(),
  permissions: z18.array(z18.enum(PERMISSIONS)).max(PERMISSIONS.length)
});
var rolePermissionsSchema = roleInputSchema.pick({ permissions: true });
var SYSTEM_ERRORS = {
  SETTING_SCOPE_UNKNOWN: "SETTING_SCOPE_UNKNOWN",
  ROLE_IS_SYSTEM: "ROLE_IS_SYSTEM",
  ROLE_IN_USE: "ROLE_IN_USE",
  LAST_OWNER: "LAST_OWNER",
  SELF_DEACTIVATE: "SELF_DEACTIVATE",
  INVITATION_INVALID: "INVITATION_INVALID",
  BACKUP_FAILED: "BACKUP_FAILED"
};
export {
  ACCEPTED_MIME_TYPES,
  ADMIN_EVENTS,
  AD_PLATFORMS,
  ANALYTICS_EVENT_NAMES,
  BANNER_PLACEMENTS,
  CART_COOKIE,
  CART_ERRORS,
  CART_TTL_DAYS,
  CATALOG_ERRORS,
  CONTENT_ERRORS,
  COURIER_CREDENTIAL_FIELDS,
  COURIER_PROVIDERS,
  CURRENCIES,
  CUSTOMER_ERRORS,
  CallOutcome,
  CollectionRuleField,
  CurrencyMismatchError,
  CustomerSegment,
  DEFAULT_CURRENCY,
  DEFAULT_LOCALE,
  DELIVERY_ERRORS,
  DELIVERY_RUN_STATUSES,
  DZ_COUNTRY_CODE,
  DeliveryFailureReason,
  DeliveryRunStatus,
  DeliveryType,
  EDITABLE_ORDER_STATUSES,
  EXPENSE_RECURRENCES,
  EXPORT_FORMATS,
  EXPORT_INLINE_LIMIT,
  EXPORT_MAX_ROWS,
  FALLBACK_CHAIN,
  FINANCE_ERRORS,
  HOME_SECTION_KINDS,
  IMPORT_COLUMNS,
  IMPORT_MAX_ROWS,
  INVENTORY_ERRORS,
  InvalidPhoneError,
  LEDGER_ACCOUNTS,
  LEDGER_KINDS,
  LOCALES,
  Locale,
  MAX_BYTES_BY_KIND,
  MAX_DOCUMENT_BYTES,
  MAX_IMAGE_BYTES,
  MAX_MODEL_BYTES,
  MAX_REPORT_DAYS,
  MAX_VIDEO_BYTES,
  MEDIA_ERRORS,
  MediaKind,
  NEWSLETTER_PROVIDERS,
  NOTIFICATION_EVENTS,
  NotificationChannel,
  ORDER_ERRORS,
  OrderSource,
  OrderStatus,
  PAGE_KINDS,
  PERMISSIONS,
  PERMISSION_GROUPS,
  PNL_GROUPINGS,
  PROMO_REJECTIONS,
  PaymentMethod,
  PaymentStatus,
  ProductStatus,
  PromotionScope,
  PromotionType,
  PurchaseOrderStatus,
  RENDITION_FORMATS,
  RENDITION_WIDTHS,
  REPORT_EXPORT_STATUSES,
  REPORT_KEYS,
  REQUIRED_IMPORT_COLUMNS,
  REVENUE_ORDER_STATUSES,
  RISK_FLAGS,
  ROLE_PERMISSIONS,
  RTL_LOCALES,
  RULE_OPERATORS_BY_FIELD,
  ReturnCondition,
  ReviewStatus,
  RoleSlug,
  RuleOperator,
  SECRET_MASK,
  SECRET_SETTING_KEYS,
  SETTING_SCOPES,
  SETTLEMENT_STATUSES,
  SORT_DIRECTIONS,
  STOCK_COUNT_STATUSES,
  STOCK_FILTER_STATES,
  STOCK_STATES,
  STOP_STATUSES,
  STOREFRONT_CACHE_TAGS,
  STOREFRONT_ERRORS,
  SYSTEM_ERRORS,
  SettlementStatus,
  ShipmentStatus,
  StockMovementReason,
  TEMPLATE_VARIABLES,
  UPLOAD_ACCEPT,
  UserType,
  VEHICLE_KINDS,
  abandonedCartPingSchema,
  acceptInvitationSchema,
  acceptInviteSchema,
  adSpendInputSchema,
  add,
  addPnl,
  addressInputSchema,
  adminListQuerySchema,
  affiliateInputSchema,
  allocate,
  allocateByRevenue,
  analyticsBatchSchema,
  analyticsEventSchema,
  announcementInputSchema,
  attributeInputSchema,
  bannerInputSchema,
  blacklistSchema,
  brandInputSchema,
  buildSrcSet,
  bulkCodeSchema,
  bulkIdsSchema,
  buyXGetYSchema,
  callLogSchema,
  cartDeliverySchema,
  cartItemInputSchema,
  cartItemPatchSchema,
  cartPromoSchema,
  cashReconcileSchema,
  catalogQuerySchema,
  categoryCreateSchema,
  categoryInputSchema,
  categoryMoveSchema,
  categoryPatchSchema,
  categoryReorderSchema,
  changePasswordSchema,
  changePercent,
  checkoutBase,
  checkoutSchema,
  clampToZero,
  collectionInputBase,
  collectionInputSchema,
  collectionPatchSchema,
  collectionPreviewSchema,
  collectionProductsSchema,
  collectionReorderSchema,
  collectionRuleSchema,
  collectionSuperRefine,
  compare,
  computePnl,
  contactCartSchema,
  contactSchema,
  costPerOrder,
  courierCredentialsSchema,
  courierInputSchema,
  createShipmentSchema,
  customerCreateSchema,
  customerGroupInputSchema,
  customerMergeSchema,
  customerNoteSchema,
  customerPatchSchema,
  dateRangeSchema,
  deliveryRunInputSchema,
  dir,
  discountPercent,
  driverInputSchema,
  dzPhoneSchema,
  editOrderItemsSchema,
  emailSchema,
  emptyPnl,
  enable2faSchema,
  expenseCategoryInputSchema,
  expenseInputSchema,
  format,
  fromMajor,
  globalSearchQuerySchema,
  homeSectionInputSchema,
  idSchema,
  inviteStaffSchema,
  isFullyTranslated,
  isLocale,
  isNegative,
  isRtl,
  isValidDzPhone,
  isZero,
  ledgerEntryInputSchema,
  localeSchema,
  locationInputSchema,
  loyaltyAdjustSchema,
  manualOrderSchema,
  marginPercent,
  maskPhone,
  max,
  mediaFolderInputSchema,
  mediaListQuerySchema,
  mediaPatchSchema,
  mediaUploadFieldsSchema,
  mediaUploadSchema,
  menuInputSchema,
  menuItemInputSchema,
  merchandisingSchema,
  min,
  missingLocales,
  money,
  moneyAmountSchema,
  multiply,
  negate,
  negotiateLocale,
  newsletterSchema,
  newsletterSyncSchema,
  normalizeDzPhone,
  notificationTemplateSchema,
  notifyMeSchema,
  optionSetSchema,
  orderAddressPatchSchema,
  orderBulkSchema,
  orderDocumentBatchSchema,
  orderListQuerySchema,
  orderNoteSchema,
  orderTagsSchema,
  orderTransitionSchema,
  otpRequestSchema,
  otpVerifySchema,
  pageInputSchema,
  paginationSchema,
  parseDzPhone,
  parseDzPhoneOrNull,
  passwordSchema,
  percentOf,
  pickRendition,
  pnlQuerySchema,
  positiveMoneySchema,
  priceScheduleInputSchema,
  productArchiveSchema,
  productAttributeSchema,
  productBulkPriceSchema,
  productBulkUpdateSchema,
  productDuplicateSchema,
  productImportOptionsSchema,
  productInputBase,
  productInputSchema,
  productListQuerySchema,
  productPatchSchema,
  productSuperRefine,
  promotionConditionSchema,
  promotionInputSchema,
  promotionSimulateSchema,
  purchaseOrderInputSchema,
  purchaseOrderItemInputSchema,
  purchaseOrderPatchSchema,
  purchaseOrderReceiveSchema,
  quickOrderSchema,
  quickPromoSchema,
  redirectInputSchema,
  refreshSchema,
  reorderSchema,
  reportExportRequestSchema,
  reportQuerySchema,
  returnRequestSchema,
  reviewInputSchema,
  reviewListQuerySchema,
  reviewModerationSchema,
  reviewReplySchema,
  reviewSubmitSchema,
  roas,
  roleInputSchema,
  rolePermissionsSchema,
  runAssignSchema,
  runReorderSchema,
  savedViewInputSchema,
  savedViewStateSchema,
  savedViewUpdateSchema,
  settingScopeSchemas,
  settlementGenerateSchema,
  settlementPaySchema,
  shareOf,
  shipmentUpdateSchema,
  shippingQuoteSchema,
  shippingRateBulkSchema,
  shippingRateInputSchema,
  shippingZoneInputSchema,
  sizeGuideInputSchema,
  slugSchema,
  slugify,
  sortSchema,
  staffInviteSchema,
  staffLoginSchema,
  staffPasswordSchema,
  staffUpdateSchema,
  stockAdjustSchema,
  stockBulkAdjustSchema,
  stockCountEntrySchema,
  stockCountStartSchema,
  stockTransferSchema,
  stopUpdateSchema,
  subtract,
  sum,
  supplierInputSchema,
  synonymInputSchema,
  t,
  tagInputSchema,
  taxIncluded,
  telLink,
  templateTestSchema,
  tierSchema,
  toMajorNumber,
  trackOrderSchema,
  trackingImportSchema,
  translated,
  translatedOptionalSchema,
  translatedSchema,
  variantGenerateSchema,
  variantInputSchema,
  variantReorderSchema,
  variantsPatchSchema,
  vehicleInputSchema,
  whatsappLink,
  wishlistItemSchema,
  zero
};
//# sourceMappingURL=index.js.map